
import React, { useMemo, useState } from "react";
import {
  ArrowUpRight,
  CalendarDays,
  Check,
  ChevronDown,
  Clock3,
  Database,
  Globe2,
  History,
  Mail,
  Phone,
  Sparkles,
  Wrench,
  Zap,
} from "lucide-react";

interface ChangelogEntry {
  date: string;
  version: string;
  title: string;
  type: "feature" | "fix" | "improvement" | "system";
  items: string[];
}

const ENTRIES: ChangelogEntry[] = [
  {
    date: "16 Σεπτεμβρίου 2026 · 12:28 Ελλάδας",
    version: "v8.18",
    title: "Ψηλότερο modal επαφής με ένα καθαρό κλείσιμο",
    type: "fix",
    items: [
      "Το modal λεπτομερειών επαφής καταλαμβάνει πλέον το 92% του διαθέσιμου ύψους σε desktop και tablet",
      "Η μεγάλη προβολή έως 1024px παραμένει, με εσωτερικό scroll για όλα τα στοιχεία και τις σημειώσεις",
      "Αφαιρέθηκε το δεύτερο χειροκίνητο εικονίδιο κλεισίματος και εμφανίζεται μόνο ένα X επάνω δεξιά",
      "Η mobile προβολή παραμένει ασφαλές bottom sheet πλήρους πλάτους",
    ],
  },
  {
    date: "16 Σεπτεμβρίου 2026 · 12:21 Ελλάδας",
    version: "v8.17",
    title: "Μεγαλύτερη προβολή επαφής για συνεργάτες",
    type: "improvement",
    items: [
      "Το modal λεπτομερειών επαφής στο partner dashboard μεγάλωσε από περίπου 672px σε έως 1024px",
      "Τα στοιχεία, οι απαντήσεις φόρμας, οι ενέργειες και οι σημειώσεις αξιοποιούν πλέον καλύτερα τις μεγάλες οθόνες",
      "Σε μικρότερες οθόνες το πλάτος προσαρμόζεται αυτόματα με ασφαλές περιθώριο από τις άκρες",
      "Η mobile προβολή παραμένει πλήρους πλάτους ως bottom sheet, με κάθετο scroll και χωρίς οριζόντια υπερχείλιση",
    ],
  },
  {
    date: "16 Σεπτεμβρίου 2026 · 12:15 Ελλάδας",
    version: "v8.16",
    title: "Σημειώσεις συνεργατών από κάθε ασφαλές lead link",
    type: "improvement",
    items: [
      "Οι συνεργάτες συνεχίζουν να γράφουν και να βλέπουν σημειώσεις μέσα από το dashboard τους",
      "Η ίδια δυνατότητα λειτουργεί πλέον και από το ασφαλές link κάθε επαφής σε SMS ή email, χωρίς υποχρεωτική σύνδεση",
      "Κάθε link παραμένει αυστηρά περιορισμένο στη συγκεκριμένη επαφή και στον τρέχοντα ανατεθειμένο συνεργάτη",
      "Η διαγραφή σημείωσης παραμένει διαθέσιμη μόνο μετά από κανονική σύνδεση, για προστασία από κατάχρηση κοινοποιημένου link",
      "Οι σημειώσεις εμφανίζονται στο κοινό ιστορικό συνεργάτη και admin, χωρίς αποστολή πρόσθετου SMS ή email",
    ],
  },
  {
    date: "10 Σεπτεμβρίου 2026 · 13:30 Ελλάδας",
    version: "v8.15",
    title: "Αναφορές συνεργατών, πλήρης εικόνα δικτύου",
    type: "improvement",
    items: [
      "Σωστά σύνολα για όλους τους συνεργάτες, χωρίς περιορισμό στους πρώτους 100",
      "Φίλτρα περιόδου, υπηρεσίας, περιοχής, ενεργών/ανενεργών και επαφών χωρίς ενημέρωση πάνω από 48 ώρες",
      "Ανάλυση σταδίων και mini-page ενεργειών ανά συνεργάτη, με πλήρη εξαγωγή CSV",
      "Νέα mobile προβολή και ευκολότερη πλοήγηση μεταξύ Γενικών, Συνεργατών, SMS και Email",
      "Σαφής διάκριση επιτυχούς αποστολής email από επιβεβαιωμένη παράδοση στο inbox",
    ],
  },
  {
    date: "9 Σεπτεμβρίου 2026 · 20:38 Ελλάδας",
    version: "v8.14",
    title: "Χρεώσεις & Λογιστήριο",
    type: "feature",
    items: [
      "Νέα ενότητα προετοιμασίας τιμολόγησης με ανάλυση υπηρεσιών και επαφών ανά συνεργάτη",
      "Καθαρή αξία, ΦΠΑ και τελικό σύνολο με παραμετροποιήσιμες ρυθμίσεις λογιστηρίου",
      "Στοιχεία τιμολόγησης συνεργατών και σαφής επισήμανση όσων χρειάζονται συμπλήρωση",
      "Προεπισκόπηση και αποστολή κατάστασης με συνημμένο CSV, χωρίς αυτόματη έκδοση παραστατικών",
      "Σταθερό ιστορικό καταστάσεων, έλεγχος επικαλυπτόμενων περιόδων και προστασία από διπλή αποστολή",
    ],
  },
  {
    date: "9 Σεπτεμβρίου 2026",
    version: "v8.13",
    title: "Διαδραστική Ξενάγηση Συνεργατών",
    type: "feature",
    items: [
      "Πρόσκληση γνωριμίας με το portal και μόνιμο κουμπί Ξενάγηση, διαθέσιμο και στο κινητό",
      "Επτά καθοδηγούμενα βήματα με πραγματική πλοήγηση σε Εργασίες, επαφές, Απόδοση, Δραστηριότητα, Χρεώσεις και Ρυθμίσεις",
      "Οπτική επισήμανση των σημείων της σελίδας, μεγάλα κουμπιά και δυνατότητα παράλειψης ή επανάληψης",
      "Εκπαιδευτική επαφή για δοκιμή αλλαγής σταδίου, χωρίς αποθήκευση, ειδοποίηση ή επίδραση σε πραγματικά leads",
      "Η επιλογή παράλειψης θυμάται τον συνεργάτη στον συγκεκριμένο browser, χωρίς πρόσθετο tracking",
    ],
  },
  {
    date: "9 Σεπτεμβρίου 2026",
    version: "v8.12",
    title: "Newsletter: Επικοινωνία με το Δίκτυο",
    type: "feature",
    items: [
      "Νέο Newsletter workspace για συνεργάτες με καμπάνιες, λίστες, templates και αναλυτικές αναφορές",
      "Οπτικός editor με blocks κειμένου, τίτλων, εικόνων, κουμπιών και επισημάνσεων, αλλαγή σειράς και προεπισκόπηση κινητού",
      "Τέσσερα έτοιμα templates της Διαθερμικής, αποθήκευση δικών σας templates και δοκιμαστική αποστολή πριν από κάθε καμπάνια",
      "Λίστες από το υπάρχον δίκτυο με αναζήτηση ανά υπηρεσία και περιοχή, καταγραφή προτιμήσεων και αποφυγή διπλής αποστολής",
      "Επιλογή συνεργατών απευθείας μέσα από τον editor, χωρίς απώλεια των μη αποθηκευμένων κειμένων",
      "Οι λίστες εμφανίζουν χωριστά τα μέλη και τους διαθέσιμους παραλήπτες, με σαφείς οδηγίες όταν δεν υπάρχει κοινό αποστολής",
      "Άμεση ή προγραμματισμένη αποστολή σε ώρα Ελλάδας, παύση, συνέχεια και ακύρωση των μη εκτελεσμένων αποστολών",
      "Αναφορές ανά συνεργάτη και σύνδεσμο για αποδοχή από SMTP, ανιχνευμένα ανοίγματα, clicks, αποτυχίες και διαγραφές",
      "Η διαγραφή αφορά μόνο το Newsletter. Οι αυτόματες ειδοποιήσεις νέων leads και υπενθυμίσεων συνεχίζουν κανονικά",
    ],
  },
  {
    date: "7 Σεπτεμβρίου 2026",
    version: "v8.11",
    title: "Όλες οι Επαφές Ορατές στο Pipeline",
    type: "fix",
    items: [
      "Το Pipeline ανοίγει πλέον σε Όλη την περίοδο, ώστε καμία ανατεθειμένη επαφή να μην κρύβεται αρχικά λόγω ημερομηνίας",
      "Τα φίλτρα Σήμερα, 7, 30 και 90 ημέρες παραμένουν διαθέσιμα για γρήγορη εστίαση όταν τα χρειάζεται ο συνεργάτης",
      "Επιβεβαιώθηκε ότι το mismatch ήταν μόνο στο αρχικό φίλτρο: το demo account είχε 16 από 16 leads στο αρχείο, ενώ το προηγούμενο 30ήμερο Pipeline εμφάνιζε 0 επειδή τα records ήταν παλαιότερα",
      "Δεν άλλαξε κανένα lead, στάδιο, ανάθεση, χρέωση, notification job ή Meta event",
      "Προστέθηκε regression guard και πέρασαν 456 PHP assertions, 15 frontend tests, TypeScript και production build",
      "Η διόρθωση έγινε live στις 13:39:31 ώρα Ελλάδας και επαληθεύτηκε στο πραγματικό partner dashboard με 16 από 16 leads ορατά χωρίς χειροκίνητη αλλαγή φίλτρου",
    ],
  },
  {
    date: "7 Σεπτεμβρίου 2026",
    version: "v8.10",
    title: "Σωστή Αλλαγή Σταδίου στα Demo Leads",
    type: "fix",
    items: [
      "Διορθώθηκε το 400 που εμφανιζόταν όταν ο LineWeb Digital Demo συνεργάτης άλλαζε στάδιο σε δοκιμαστική επαφή",
      "Τα production leads χρησιμοποιούν UUID, ενώ τα σκόπιμα seeded demo leads έχουν ασφαλή compact IDs όπως demo-lead-003. Το κοινό API contract υποστηρίζει πλέον και τις δύο έγκυρες μορφές",
      "Η ίδια συμβατότητα εφαρμόζεται στις λεπτομέρειες, στην καταγραφή προβολής, στην αλλαγή σταδίου και στα ασφαλή exact-lead links",
      "Τα partner και magic-link ownership checks παραμένουν ακριβώς ίδια. Ένας συνεργάτης δεν μπορεί να διαβάσει ή να αλλάξει lead άλλου συνεργάτη",
      "Το partner UI εμφανίζει πλέον το πραγματικό server μήνυμα αποτυχίας και δεν αφήνει unhandled promise error στο browser console",
      "Το dropdown σταδίου κλειδώνει μόνο όσο εκτελείται η συγκεκριμένη αλλαγή και ενεργοποιείται ξανά αμέσως μετά την επιτυχία ή την αποτυχία",
      "Δεν άλλαξε κανένα πραγματικό lead, ανάθεση, υπηρεσία, notification job ή Meta form κατά τη διόρθωση",
      "Πέρασαν 455 PHP assertions, 15 frontend tests, PHP lint, TypeScript και production build πριν από τη δημοσίευση",
      "Η πλήρης διορθωμένη ροή έγινε live στις 12:52:46 ώρα Ελλάδας και επαληθεύτηκε στο πραγματικό partner dashboard με διαδοχική αλλαγή και επαναφορά demo σταδίου",
    ],
  },
  {
    date: "3 Σεπτεμβρίου 2026",
    version: "v8.9",
    title: "Ανακαινίζω: Προτεραιότητα Συμμετοχής & Κάλυψη από Όλο το Δίκτυο",
    type: "improvement",
    items: [
      "Οι επαφές Πλήρης ανακαίνιση δοκιμάζουν πρώτα τους συνεργάτες που δήλωσαν συμμετοχή στο πρόγραμμα και μόνο όταν δεν υπάρχει in-radius κάλυψη περνούν στο υπόλοιπο ενεργειακό δίκτυο",
      "Το fallback περιλαμβάνει ενεργούς συνεργάτες με αντλίες θερμότητας, κλιματισμό, φωτοβολταϊκά, φυσικό αέριο ή ηλιακά. Δεν περιλαμβάνει Άλλο ή Εξοικονομώ και δεν παρακάμπτει ποτέ τη δηλωμένη ακτίνα",
      "Η ίδια προτεραιότητα εφαρμόζεται στο realtime matching, στις προτάσεις χειροκίνητης ανάθεσης και στους ελέγχους συμβατότητας frontend/backend",
      "Νέο εμφανές badge Πρόγραμμα Ανακαινίζω υπάρχει στις κάρτες και στις λεπτομέρειες που βλέπει ο συνεργάτης, καθώς και στο email και στο SMS νέας επαφής",
      "Από 11 υφιστάμενες μη ανατεθειμένες επαφές πλήρους ανακαίνισης, 7 βρήκαν ασφαλή in-radius κάλυψη και ανατέθηκαν. Οι 4 χωρίς κάλυψη παρέμειναν στο Operations για manual assign",
      "Για τις 7 αναθέσεις στάλθηκαν κανονικά 7 partner και 7 customer emails. Έξι partner SMS προγραμματίστηκαν για τις 08:00 λόγω quiet hours και ένα καταγράφηκε ως opt-out suppression",
      "Πέρασαν 444 PHP assertions, 15 frontend tests, TypeScript, scoped ESLint, PHP/bash lint, production build και live auth/API/DB checks",
      "Το routing έγινε live στις 20:52:12 και το Lineweb Updates v8.9 δημοσιεύτηκε πρώτη φορά στις 20:56:58 ώρα Ελλάδας, με ξεχωριστά scoped backups και rollback manifest",
    ],
  },
  {
    date: "3 Σεπτεμβρίου 2026",
    version: "v8.8",
    title: "Οι Απαντήσεις της Φόρμας Δίπλα στην Επαφή",
    type: "feature",
    items: [
      "Νέα ενότητα Απαντήσεις φόρμας στη σελίδα από SMS/email, στις λεπτομέρειες του partner dashboard και στην προβολή επαφής του admin",
      "Εμφανίζονται οι πραγματικές επιλογές για υπάρχουσα θέρμανση, υπηρεσία και χρόνο ενδιαφέροντος, με καθαρή εμφάνιση και στο κινητό",
      "Το χρονοδιάγραμμα της συγκεκριμένης επαφής προτιμά την ακριβή απάντηση του πελάτη αντί για την προεπιλεγμένη τιμή του CRM",
      "Οι νέες Meta επαφές αποθηκεύουν ξεχωριστά τις εγκεκριμένες απαντήσεις. Δεν αντιγράφονται στοιχεία συγκατάθεσης, τεχνικά IDs ή μη ελεγμένες προσωπικές ερωτήσεις",
      "Οι τεχνικές πληροφορίες καμπάνιας και οι προειδοποιήσεις διπλότυπων αφαιρούνται από τα σχόλια που επιστρέφονται στους συνεργάτες",
      "Ασφαλής συμπλήρωση πρόσφατων επαφών από τη Meta, μόνο όπου διατίθενται ακόμη οι απαντήσεις, χωρίς νέα ειδοποίηση ή αλλαγή ανάθεσης, σταδίου και ιστορικού προβολής",
      "Διατηρούνται τα ασφαλή links χωρίς login για τη συγκεκριμένη επαφή. Η προβολή απαντήσεων ακολουθεί τα ίδια δικαιώματα πρόσβασης",
    ],
  },
  {
    date: "3 Σεπτεμβρίου 2026",
    version: "v8.7",
    title: "Διπλότυπα: Ιστορικό Εμφανίσεων με Ένα Κλικ",
    type: "improvement",
    items: [
      "Το badge Διπλότυπο στη λίστα επαφών ανοίγει πλέον αναλυτικό ιστορικό αντί για απλό tooltip",
      "Για κάθε καταχώρηση εμφανίζονται ημερομηνία και ώρα Ελλάδας, υπηρεσία, τωρινός συνεργάτης ή Χωρίς ανάθεση, στάδιο και άμεσο άνοιγμα της επαφής",
      "Η επιλεγμένη καταχώρηση ξεχωρίζει από τις άλλες εμφανίσεις, με τις νεότερες πρώτες και σελιδοποίηση σε ολόκληρο το CRM",
      "Το ιστορικό φορτώνεται μόνο όταν πατηθεί το badge, με ανανέωση, χειρισμό σφαλμάτων και responsive παράθυρο για μικρές οθόνες",
      "Διορθώθηκε το HTML caching ώστε η ανανέωση της εφαρμογής να ελέγχει τη νέα έκδοση, χωρίς να καταργείται το γρήγορο cache των hashed assets",
      "Η αντιστοίχιση παραμένει με το ίδιο αποθηκευμένο τηλέφωνο. Διαφορετικά αιτήματα ή υπηρεσίες δεν συγχωνεύονται και δεν αλλάζει κανένα lead, ανάθεση ή ειδοποίηση",
      "Νέο admin-only API με ελέγχους δικαιωμάτων, 39 πρόσθετους ελέγχους για ιστορικό και ασφάλεια, και ανεξάρτητη σύγκριση των live αποτελεσμάτων με τη βάση",
    ],
  },
  {
    date: "3 Σεπτεμβρίου 2026",
    version: "v8.6",
    title: "Ανάθεση με Χάρτη, Ακτίνα & Απόκλιση",
    type: "improvement",
    items: [
      "Η Διαχείριση & Ανάθεση χωρίζεται σε δύο στήλες: επιλογή συνεργάτη και διαδραστικός χάρτης κάλυψης. Στο κινητό εμφανίζονται διαδοχικά",
      "Κάθε συνεργάτης δείχνει απόσταση από τον πελάτη, δηλωμένη ακτίνα και πραγματική υπέρβαση σε χιλιόμετρα, μαζί με αναζήτηση και φίλτρο κάλυψης",
      "Ο χάρτης δείχνει πελάτη, συνεργάτη, κύκλο ακτίνας και ευθεία σύνδεση. Οι αποστάσεις είναι γεωγραφικές, όχι οδική διαδρομή, και η θέση μπορεί να είναι το κέντρο του Τ.Κ.",
      "Η ένδειξη Κοντά, εκτός ακτίνας αφορά έως 50% υπέρβαση και δεν μεγαλώνει την αυτόματη κάλυψη. Χειροκίνητη ανάθεση εκτός ή χωρίς γνωστή κάλυψη απαιτεί ρητή επιβεβαίωση στη σελίδα",
      "Η λίστα Ανακαινίζω - Ενεργειακά περιλαμβάνει πλέον και το υπόλοιπο ενεργειακό δίκτυο, όπως ήδη επιτρέπει ο server. Διατηρούνται η προτεραιότητα enrolled συνεργατών και η δίκαιη κατανομή εντός ακτίνας",
      "Τα στοιχεία της συγκεκριμένης επαφής ανανεώνονται απευθείας, ακόμη και για παλιότερες επαφές εκτός του πρόσφατου working set",
      "Δεν αλλάζουν Meta intake, αυτόματη ανάθεση, ακτίνες, χρεώσεις ή ουρά ειδοποιήσεων. Δεν έγινε δοκιμαστική αποστολή ή πραγματική επανανάθεση για το QA",
    ],
  },
  {
    date: "2 Σεπτεμβρίου 2026",
    version: "v8.5",
    title: "Ανακαινίζω: Νέες Υπηρεσίες & Ελεγμένο Partner Routing",
    type: "feature",
    items: [
      "Προστέθηκαν δύο ανεξάρτητες υπηρεσίες: Ανακαινίζω - Ενεργειακά συστήματα και Ανακαινίζω - Πλήρης ανακαίνιση, σε Meta Hub, αναθέσεις, συνεργάτες, φίλτρα, reports, email και SMS",
      "Ελέγχθηκαν 50 αιτήσεις συνεργατών από το diathermiki.gr με αποδιπλοποίηση και κανόνα ότι η νεότερη δήλωση υπερισχύει",
      "Μόνο ρητή συμμετοχή, επιθυμία λήψης leads και ενεργή αντίστοιχη κατηγορία θεωρούνται επιλέξιμες. False, null, ανάκληση και inactive CRM record αποκλείονται",
      "Το δίκτυο έχει πλέον 33 ενεργούς και routing-ready συνεργάτες για ενεργειακά συστήματα και 20 για πλήρη ανακαίνιση",
      "Τριάντα συνεργάτες υπήρχαν ήδη στο CRM. Οι ΓΙΑΛΑΜΑΣ, POLISERVICE ΙΚΕ και ΛΟΝΤΟΣ ΑΝΤΡΕΑΣ ΤΕΧΝΗ GROUP προστέθηκαν από το επαληθευμένο μητρώο με πλήρη γεωγραφικά στοιχεία",
      "Επτά αιτήσεις χωρίς ασφαλή αντιστοίχιση και δύο ανενεργοί συνεργάτες έμειναν σκόπιμα εκτός για χειροκίνητο έλεγχο",
      "Η ανάθεση παραμένει αυστηρή: σωστή υπηρεσία, ενεργός συνεργάτης, εντός ακτίνας και δίκαιη κατανομή. Χωρίς κάλυψη το lead μένει χωρίς συνεργάτη στο Operations Inbox",
      "Το Meta Lead Hub αναγνωρίζει τις δύο νέες απαντήσεις, αλλά κάθε νέα πραγματική φόρμα παραμένει κλειστή μέχρι να γίνει Sync, mapping και ρητή ενεργοποίηση του form ID",
      "Πέρασαν TypeScript, 10 PHP suites με 343 assertions και production build, χωρίς fake lead ή notification",
      "Η λειτουργία ανέβηκε στις 13:26:14, το partner enrollment επαληθεύτηκε στις 13:27:29 και το Lineweb Updates v8.5 δημοσιεύτηκε πρώτη φορά στις 13:32:18 ώρα Ελλάδας, με ξεχωριστά versioned DB/code backups και χωρίς αλλαγή σε άλλο domain",
    ],
  },
  {
    date: "1 Σεπτεμβρίου 2026",
    version: "v8.4",
    title: "Ακριβείς Χρεώσεις από Ολόκληρη τη Βάση",
    type: "fix",
    items: [
      "Διορθώθηκε το σοβαρό σφάλμα όπου η σελίδα Χρεώσεων χρησιμοποιούσε μόνο τα 100 πιο πρόσφατα leads και παρουσίαζε ελλιπή totals για ιστορικές περιόδους και CSV",
      "Νέο ασφαλές admin billing API υπολογίζει πλέον όλα τα ποσά απευθείας από ολόκληρη τη MySQL βάση, με σταθερή τιμή 3€ ανά ανατεθειμένο lead",
      "Τα leads χωρίς συνεργάτη εμφανίζονται ξεχωριστά και δεν χρεώνονται, ενώ οι πραγματικές ιστορικές αναθέσεις σε ανενεργούς συνεργάτες δεν χάνονται πλέον από τα totals",
      "Οι επιλογές περιόδου είναι σαφείς: τρέχουσα εβδομάδα, τρέχων μήνας, προηγούμενος μήνας, τρέχον τρίμηνο, τρέχον έτος, όλο το ιστορικό και προσαρμοσμένες ημερομηνίες",
      "Η λίστα χρησιμοποιεί server-side pagination, partner state και search filters, ενώ το Πλήρες CSV δημιουργείται από ολόκληρο το filtered dataset με προστασία από spreadsheet formulas",
      "Το τελικό live snapshot επαλήθευσε Σεπτέμβριο 7 συνολικά / 3 χρεώσιμα / 4 χωρίς συνεργάτη / 9€, Αύγουστο 293 / 290 / 3 / 870€ και όλο το ιστορικό 2.973 / 2.966 / 7 / 8.898€",
      "Πέρασαν 337 PHP assertions, TypeScript, scoped ESLint, PHP και bash lint, production build, anonymous 401 και authenticated live UI/API comparison",
      "Το billing fix έγινε live στις 13:09:25 και το Lineweb Updates v8.4 δημοσιεύτηκε πρώτη φορά στις 13:17:22 ώρα Ελλάδας με targeted release 20260901T101722Z, αυτόματα backups και χωρίς αλλαγή σε άλλο domain ή global Plesk setting",
    ],
  },
  {
    date: "29 Αυγούστου 2026",
    version: "v8.3",
    title: "Friendly Energy Illustrations — Νέο Diathermiki Visual System",
    type: "improvement",
    items: [
      "Δημιουργήθηκαν τέσσερα αποκλειστικά Diathermiki clipart γραφικά για νέα επαφή, υπενθύμιση σταδίου, δίκτυο συνεργατών και analytics, με κοινή premium 2.5D αισθητική και ενεργειακά στοιχεία",
      "Όλα έχουν πραγματικό διαφανές φόντο, χωρίς κείμενο, logo ή watermark, ώστε να λειτουργούν καθαρά πάνω σε λευκές, γαλάζιες και έγχρωμες επιφάνειες",
      "Οι εικόνες διατηρούν την πλήρη ανάλυσή τους από 1254×1254 έως 1536×1024 και μετατράπηκαν σε WebP υψηλής ποιότητας με βάρος 119–245 KB",
      "Νέο reusable FriendlyIllustration component ορίζει έγκυρες παραλλαγές, πραγματικές διαστάσεις, lazy loading, async decoding και decorative accessibility χωρίς layout shift",
      "Τα γραφικά μπήκαν επιλεκτικά σε empty states των Leads, Συνεργατών, Αναφορών, SMS/email analytics, Partner Care και partner portal, χωρίς να επιβαρύνουν πίνακες ή πυκνά KPI",
      "Το stage-reminder artwork εμφανίζεται ως φιλικό υποστηρικτικό visual στην ενεργή κατάσταση του Partner Care, ενώ στο κινητό κρύβεται για να διατηρείται συμπαγής η κρίσιμη πληροφορία",
      "Πέρασαν 310 PHP assertions, TypeScript, scoped ESLint, git diff check, alpha/dimension verification και production build",
      "Live desktop 1512px και mobile 390px QA επιβεβαίωσαν σωστό transparent render, μηδενικό horizontal overflow και καθαρό browser console",
      "Και τα τέσσερα production assets επιστρέφουν HTTP 200, ενώ το MIME επιβεβαιώθηκε ως image/webp",
      "Το Lineweb Updates v8.3 δημοσιεύτηκε πρώτη φορά στις 20:53:14 ώρα Ελλάδας με το subscription-scoped release 20260829T175314Z και rollback artifacts mode 0600",
    ],
  },
  {
    date: "29 Αυγούστου 2026",
    version: "v8.2",
    title: "Partner Care: Αναλυτικό Click Attribution ανά Lead",
    type: "improvement",
    items: [
      "Το Partner Care ξεχωρίζει πλέον τα μοναδικά leads που πατήθηκαν από τα συνολικά πατήματα, ώστε τα επαναλαμβανόμενα taps να μην φουσκώνουν το πραγματικό engagement",
      "Κάθε reminder digest ανοίγει αναλυτικά και δείχνει ποια ακριβώς επαφή περιείχε, αν πατήθηκε, πόσες φορές, καθώς και το πρώτο και τελευταίο click",
      "Η ομάδα μπορεί να ανοίξει απευθείας το αντίστοιχο admin lead από κάθε γραμμή, χωρίς αναζήτηση ή έκθεση στοιχείων επικοινωνίας στο telemetry",
      "Το privacy-safe tracking παραμένει aggregate ανά job, partner και lead, χωρίς IP address, user agent, cookies ή arbitrary redirect destination",
      "Η οθόνη διευκρινίζει ότι το click είναι ισχυρότερο signal από το open pixel, αλλά ένα εταιρικό security scanner μπορεί σπάνια να επισκεφθεί αυτόματα το signed link. Η αλλαγή σταδίου παραμένει το καθαρότερο business signal",
      "Πέρασαν 310 PHP assertions, TypeScript, scoped ESLint, PHP lint, production build και live access-control/API checks χωρίς fake lead ή fake click",
      "Το functional release 20260829T111627Z δημοσιεύτηκε στις 14:16:27 ώρα Ελλάδας μόνο στο app.diathermiki.gr, με versioned code/env/DB backup και rollback manifest mode 0600",
      "Το Lineweb Updates v8.2 δημοσιεύτηκε πρώτη φορά στις 14:20:03 ώρα Ελλάδας με το metadata release 20260829T112003Z",
    ],
  },
  {
    date: "29 Αυγούστου 2026",
    version: "v8.1",
    title: "Partner Care — Live Reminders, Delivery & Dashboard Visibility",
    type: "feature",
    items: [
      "Νέα admin-only σελίδα Partner Care με πραγματικά reminder deliveries, retries, failures, detected opens, lead/dashboard clicks και αναλυτική κατάσταση ανά συνεργάτη",
      "Για κάθε συνεργάτη φαίνονται η ενεργοποίηση κωδικού, η πρώτη σύνδεση και η τελευταία σύνδεση, ώστε η ομάδα να γνωρίζει ποιοι χρησιμοποιούν πράγματι το dashboard",
      "Τα detected opens χαρακτηρίζονται καθαρά ως ένδειξη και όχι ως απόδειξη ανάγνωσης, επειδή Gmail, Apple Mail και security proxies μπορούν να φορτώνουν εικόνες αυτόματα",
      "Η νέα privacy-conscious telemetry δεν αποθηκεύει IP ή user agent, συγκεντρώνει επαναλαμβανόμενα events και δεν δέχεται arbitrary redirect destinations",
      "Τα reminder clicks δημιουργούν server-side νέο exact-lead ή dashboard invite link, χωρίς να εκθέτουν bearer fragments σε access logs",
      "Η πηγή onboarding διατηρείται από το invite open έως το password setup, ενώ το Partner Care API απαιτεί ενεργό admin session ή service key",
      "Οι υπενθυμίσεις ενεργοποιήθηκαν στις 13:57:34 ώρα Ελλάδας με hard cutoff NEW_LEADS_ONLY αποκλειστικά στη βάση L3adsDiath",
      "Ο άμεσος scheduler έλεγχος επέστρεψε 0 eligible leads, 0 jobs και 0 items, επομένως κανένα από τα 342 ιστορικά SLA alerts δεν μετατράπηκε σε email",
      "Authenticated desktop 1512px και mobile 390px QA είχε μηδενικό horizontal overflow, καθαρό console και touch controls τουλάχιστον 40px",
      "Πέρασαν 305 PHP assertions, TypeScript, scoped ESLint, PHP lint, deploy syntax, production build και live API/security checks",
      "Το functional Partner Care release επαληθεύτηκε στις 13:55:06 και το Lineweb Updates v8.1 δημοσιεύτηκε στις 14:03:01 ώρα Ελλάδας, με versioned subscription-scoped releases και rollback backups mode 0600",
    ],
  },
  {
    date: "29 Αυγούστου 2026",
    version: "v8.0",
    title: "Branded Email Experience — Νέα Επαφή & Partner Reminders",
    type: "improvement",
    items: [
      "Το email νέας επαφής ξεκινά πλέον με το νέο επίσημο γραφιστικό της Διαθερμικής και συνεχίζει με καθαρή ιεραρχία, ευανάγνωστη κάρτα στοιχείων και άμεσο CTA προς το ασφαλές exact-lead link",
      "Το φιλικό stage reminder απέκτησε ξεχωριστό branded header και πιο φωτεινή σύνθεση, ώστε να διακρίνεται ο σκοπός του χωρίς να μοιάζει με το email νέου lead",
      "Και τα δύο headers διατηρούν ολόκληρη την αρχική ανάλυση 1672×941 σε WebP υψηλής ποιότητας, με βάρος μόλις 85 KB και 102 KB αντίστοιχα",
      "Οι εικόνες σερβίρονται live με HTTP 200 και σωστό MIME image/webp. Υπάρχει περιγραφικό alt text για clients που δεν εμφανίζουν WebP",
      "Το new-lead template κάνει ασφαλές escaping σε όλα τα στοιχεία, μετατρέπει το τηλέφωνο σε άμεσο tap-to-call και κρατά το lead link χωρίς υποχρεωτικό login",
      "Τα synthetic emails επισημαίνονται πλέον καθαρά με [ΔΟΚΙΜΗ] στο subject ώστε να μην εκλαμβάνονται ως πραγματικές αναθέσεις",
      "Desktop 900px και mobile 390px browser QA επιβεβαίωσαν καθαρές αναλογίες, σωστή τυπογραφία, responsive κάρτες και touch-friendly CTA χωρίς horizontal overflow",
      "Τα δύο νέα production-template tests στάλθηκαν μόνο στο προσωπικό Lineweb test inbox και έγιναν δεκτά από Gmail με SMTP 250 στις 13:35:05 ώρα Ελλάδας",
      "Πέρασαν 270 PHP assertions, TypeScript, PHP lint, production build και release health checks. Δεν δημιουργήθηκε fake lead, reminder item ή onboarding event",
      "Το Lineweb Updates v8.0 δημοσιεύτηκε στις 13:31:36 ώρα Ελλάδας. Ο αυτοματισμός stage reminders παραμένει σκόπιμα απενεργοποιημένος",
    ],
  },
  {
    date: "29 Αυγούστου 2026",
    version: "v7.9",
    title: "Partner Care — Φιλικά Reminders & Ασφαλές Dashboard Onboarding",
    type: "feature",
    items: [
      "Νέα όμορφα, mobile-first email digests υπενθυμίζουν φιλικά στον συνεργάτη ποιες επαφές χρειάζονται ενημέρωση σταδίου, με ένα exact-lead κουμπί ανά επαφή και χωρίς υποχρεωτικό login",
      "Κάθε συνεργάτης λαμβάνει το πολύ ένα συγκεντρωτικό email την ημέρα: πρώτη υπενθύμιση στις 48 ώρες και μία τελική στις 120 ώρες, χωρίς τρίτο μήνυμα ή μεμονωμένο email για κάθε lead",
      "Η ενημέρωση σταδίου εξηγείται ως πρακτική βοήθεια για καλύτερη αξιολόγηση καμπανιών και σταδιακή βελτίωση της συνάφειας των επαφών, χωρίς μη ρεαλιστικές υποσχέσεις",
      "Το email προσφέρει προαιρετική ενεργοποίηση του partner dashboard, αλλά δεν μετατρέπει το reminder link σε login: ο κωδικός δημιουργείται μόνο μέσω δεύτερου single-use email στο ήδη καταχωρημένο εταιρικό inbox",
      "Τα setup tokens αποθηκεύονται hashed, λήγουν σε 30 λεπτά και χρησιμοποιούνται μία φορά. Το αρχικό invite μένει στο URL fragment και δεν εμφανίζεται στα συνηθισμένα access logs",
      "Η αλλαγή σταδίου ή συνεργάτη ακυρώνει pending reminders. Η αποστολή γίνεται από durable queue με idempotency, retries και Operations alert αν ο provider αποτύχει",
      "Το rollout έχει hard cutoff: εγκαταστάθηκε απενεργοποιημένο και, όταν ενεργοποιηθεί, θα εξετάσει μόνο leads από την ώρα ενεργοποίησης και μετά. Τα παλιά SLA alerts δεν μπορούν να σταλούν μαζικά",
      "Το Email Studio δείχνει readiness, delivery και onboarding counters και απαιτεί δύο επιτυχημένα test templates στην ίδια admin συνεδρία πριν ξεκλειδώσει την ενεργοποίηση",
      "Τα δύο branded test emails στάλθηκαν μόνο στο προσωπικό Lineweb test inbox με synthetic δεδομένα και έγιναν δεκτά από Gmail με SMTP 250, χωρίς fake lead, partner token ή production reminder job",
      "Desktop και mobile 390px QA επιβεβαίωσαν σωστή τυπογραφία, responsive buttons, επίσημο λογότυπο, μηδενικό horizontal overflow και καθαρό browser console",
      "Πέρασαν 261 PHP assertions, TypeScript, scoped ESLint, PHP lint, deploy syntax και production build. Leads, αναθέσεις και Meta/notification queues έμειναν ακριβώς ίδια μετά το release",
      "Το Lineweb Updates v7.9 δημοσιεύτηκε στις 13:03:59 ώρα Ελλάδας. Η μαζική λειτουργία παραμένει σκόπιμα κλειστή μέχρι την τελική επιβεβαίωση των δύο test emails",
    ],
  },
  {
    date: "25 Αυγούστου 2026",
    version: "v7.8",
    title: "Integrations Control Center — Ασφαλές Production Readiness",
    type: "improvement",
    items: [
      "Το /admin/settings ξανασχεδιάστηκε ως responsive production control center για email, SMS, Google Maps, Meta tracking και partner access",
      "Η σελίδα δεν κατεβάζει πλέον ολόκληρο το site_settings record και δεν εμφανίζει SMTP, Twilio, Maps, Meta ή registration credentials στον browser",
      "Νέο purpose-specific admin-session-only API επιστρέφει μόνο readiness booleans, aggregate counters, operational timestamps και την εγκεκριμένη ταυτότητα email αποστολέα",
      "Regression test με έξι canary secrets επιβεβαιώνει ότι κανένα provider credential δεν μπορεί να εμφανιστεί στο JSON response ή στο typed frontend contract",
      "Καταργήθηκε το επικίνδυνο γενικό save όλων των integrations· από τη σελίδα αλλάζει μόνο sender name/email με server validation και υποχρεωτικό diathermiki.gr mail alignment",
      "Κάθε integration ξεχωρίζει πλέον το server configuration από το πραγματικό operational evidence και οδηγεί στο αντίστοιχο Meta, Maps, SMS, email ή partner workspace",
      "Τα provider credentials αλλάζουν μόνο με συντονισμένο rotation, live verification και rollback· δεν υπάρχει automatic revoke ή τυφλή αντικατάσταση από το admin",
      "Ο νέος έλεγχος ανέδειξε 93 Meta CRM feedback jobs με μηδενικές προσπάθειες και εντόπισε τη ρίζα στο lock file που δεν είχε δημιουργηθεί από το versioned release",
      "Το release workflow δημιουργεί πλέον και τα δύο worker locks με subscription ownership, ώστε notifications και Meta CRM feedback να εκτελούνται αξιόπιστα από την per-minute cron",
      "Η πραγματική ουρά ολοκληρώθηκε με 89 Meta HTTP 200, 4 terminal missing-lead audit rows και 0 pending/retry, χωρίς fake submission ή αλλαγή σε lead, stage, assignment και notifications",
      "Desktop 1512px και mobile 390px QA επιβεβαίωσαν μηδενικό horizontal overflow, ελάχιστο touch target 44px και καθαρό browser console",
      "Πέρασαν TypeScript, scoped ESLint, production build, PHP lint, bash syntax και 223 PHP assertions χωρίς αλλαγή σε lead, στάδιο, ανάθεση ή notification job",
      "Το Lineweb Updates v7.8 δημοσιεύτηκε στις 14:55:07 ώρα Ελλάδας, μετά το ασφαλές settings release και το worker recovery",
    ],
  },
  {
    date: "20 Αυγούστου 2026",
    version: "v7.7",
    title: "Meta Lead Quality Loop",
    type: "feature",
    items: [
      "Το CRM ενημερώνει πλέον τη Meta για την πραγματική εξέλιξη των leads και όχι μόνο για τη συμπλήρωση της αρχικής φόρμας",
      "Τα στάδια Νέο, Έγινε επικοινωνία, Ποιοτικό lead και Έκλεισε η δουλειά μεταφράζονται σε καθαρά αποτελέσματα καμπάνιας",
      "Η αποστολή γίνεται στο παρασκήνιο με ασφαλή ουρά και αυτόματες επαναλήψεις, ώστε μια προσωρινή αστοχία της Meta να μην επηρεάζει την εργασία της ομάδας",
      "Το Meta Lead Hub ξεχωρίζει πλέον καθαρά τη λήψη νέων φορμών από την επιστροφή αποτελεσμάτων προς τη Meta",
      "Νέα κάρτα κατάστασης δείχνει αν η σύνδεση είναι έτοιμη, πόσες ενημερώσεις περιμένουν, πόσες στάλθηκαν και ποιες χρειάζονται έλεγχο",
      "Δεν έγινε μαζική αποστολή παλιών leads και δεν άλλαξε κανένα υπάρχον lead, στάδιο, ανάθεση ή ειδοποίηση κατά την ενεργοποίηση",
      "Η πρώτη ασφαλής δημοσίευση ολοκληρώθηκε στις 14:10:42 ώρα Ελλάδας με ενεργή σύνδεση και κενή ουρά",
    ],
  },
  {
    date: "5 Αυγούστου 2026",
    version: "v7.6",
    title: "Ροή Lead — Πραγματικό Operational Blueprint",
    type: "improvement",
    items: [
      "Το /admin/journey ξανασχεδιάστηκε ως read-only operational blueprint της σημερινής production ροής και δεν περιγράφει πλέον το παλιό Sheets/direct-send μοντέλο",
      "Τρεις πραγματικές πηγές — Meta Lead Ads, φόρμα site και χειροκίνητο admin lead — συγκλίνουν οπτικά στην ίδια ασφαλή διαδικασία validation, geocoding, matching και ανάθεσης",
      "Η Meta διαδρομή εξηγεί το identifier-only HMAC handoff, το active Page/form mapping και το fb_lead_id idempotency χωρίς να εμφανίζει credentials ή προσωπικά δεδομένα",
      "Ο κλάδος matching ξεχωρίζει καθαρά τη transactional ανάθεση από το unassigned lead που μένει χωρίς συνεργάτη και ανοίγει Operations alert για manual assignment",
      "Ο audit εντόπισε και αφαίρεσε παλιό postal-prefix/fair-spread fallback: χωρίς επαληθευμένες συντεταγμένες και κάλυψη ακτίνας, το shared matcher επιστρέφει πλέον null αντί να αναθέτει εκτός κανόνα",
      "Οι ειδοποιήσεις ευθυγραμμίστηκαν με την πραγματική durable queue: άμεσο partner email, partner SMS 08:00–20:00, customer email μόνο όταν υπάρχει και κανένα customer SMS",
      "Η σελίδα εξηγεί retries, quiet hours, SMS suppression, provider failure alerts και τη συμπεριφορά ακύρωσης/επανέκδοσης jobs σε reassignment",
      "Το partner access αποτυπώνεται σωστά ως 30ήμερο exact-lead signed link χωρίς υποχρεωτικό login, ενώ το πλήρες portal παραμένει password protected",
      "Προστέθηκαν πραγματικά links προς Meta Lead Hub, Operations Inbox, χειροκίνητη ανάθεση και SMS/email log, μαζί με responsive source selector και σαφή guardrails",
      "Desktop 1440px και mobile 390px QA επιβεβαίωσαν μηδενικό horizontal overflow, 76px source controls, 88px quick links, σωστή εναλλαγή και 0 browser warnings/errors",
      "Πέρασαν TypeScript, scoped ESLint, production build και 173 PHP matching/Meta/notification/magic-link/security assertions· το full lint διατηρεί μόνο τα 59 γνωστά legacy errors",
      "Η πρώτη λειτουργική δημοσίευση επαληθεύτηκε στις 14:41:05 ώρα Ελλάδας, χωρίς αλλαγή σε lead, συνεργάτη, ανάθεση ή notification job",
    ],
  },
  {
    date: "5 Αυγούστου 2026",
    version: "v7.5",
    title: "Διαχειριστές — Ασφαλείς Λογαριασμοί & Mobile Control Center",
    type: "improvement",
    items: [
      "Το /admin/admins έγινε καθαρό responsive control center με αναζήτηση, φίλτρα κατάστασης, πραγματικά KPI και ξεχωριστές κάρτες λογαριασμών",
      "Κάθε κάρτα δείχνει ενεργή κατάσταση, τελευταίο login, ημερομηνία δημιουργίας και σαφή ένδειξη του λογαριασμού με τον οποίο είστε συνδεδεμένοι",
      "Η λίστα, η δημιουργία και η διαγραφή μεταφέρθηκαν από το generic database gateway σε purpose-specific admin-session-only API με CSRF και prepared statements",
      "Οι νέοι κωδικοί απαιτούν 12–128 χαρακτήρες και αποθηκεύονται με Argon2id όπου υποστηρίζεται, χωρίς password hashes στο response ή στο browser",
      "Η δημιουργία admin και credentials γίνεται σε ένα transaction, ενώ το username και το email ελέγχονται server-side για διπλοεγγραφές",
      "Ο server απαγορεύει τη διαγραφή του τρέχοντος λογαριασμού και κλειδώνει τους ενεργούς admins πριν επιτρέψει διαγραφή, ώστε να μη μείνει το σύστημα χωρίς πρόσβαση",
      "Desktop και 390px mobile QA επιβεβαίωσαν 0 horizontal overflow, 44px controls, λειτουργικό create dialog και 0 browser errors χωρίς πραγματική δημιουργία ή διαγραφή admin",
      "Το live endpoint απορρίπτει anonymous request με 401 και το production snapshot παρέμεινε σε 3 ενεργούς λογαριασμούς χωρίς data mutation",
      "Πέρασαν TypeScript, scoped ESLint, production build, PHP lint και 123 PHP security/notification/Meta assertions",
    ],
  },
  {
    date: "5 Αυγούστου 2026",
    version: "v7.4",
    title: "Νέος Συνεργάτης — Ασφαλής Δημιουργία & Routing Readiness",
    type: "improvement",
    items: [
      "Το /admin/partners/new έγινε ολοκληρωμένο responsive workspace με σαφή βήματα για routing, ειδοποιήσεις, portal και περιοχή κάλυψης",
      "Η δημιουργία συνεργάτη πέρασε από το παλιό γενικό table gateway σε purpose-specific admin/service-only POST με CSRF, strict allowlists και prepared SQL",
      "Το id δημιουργείται αποκλειστικά στον server και το API επιστρέφει 201 με το πλήρες ασφαλές partner record, χωρίς password hash ή reset token",
      "Διπλό τηλέφωνο ή email απορρίπτεται πριν την εγγραφή με field-specific μήνυμα, χωρίς να αποκαλύπτονται στοιχεία υπάρχοντος συνεργάτη",
      "Η σελίδα εξηγεί πριν την αποθήκευση ότι η ενεργοποίηση αφορά μόνο επόμενα επιλέξιμα leads και δεν αλλάζει ιστορικές αναθέσεις ή ήδη σταλμένες ειδοποιήσεις",
      "Η δημιουργία δεν στέλνει αυτόματα setup email/SMS και δεν επιβάλλει login· τα ασφαλή exact-lead links συνεχίζουν να λειτουργούν χωρίς κωδικό",
      "Μετά την επιτυχία ο admin μεταφέρεται στο ακριβές dashboard του νέου συνεργάτη για έλεγχο ετοιμότητας αντί να επιστρέφει σε γενική λίστα",
      "Mock-only QA επιβεβαίωσε το ακριβές POST payload, redirect, μηδενικό horizontal overflow και 48px mobile action χωρίς παραγωγική εγγραφή",
      "Πέρασαν TypeScript, scoped ESLint, production build, PHP lint και 148 PHP assertions χωρίς αλλαγή σε πραγματικό partner, lead, assignment ή notification",
    ],
  },
  {
    date: "4 Αυγούστου 2026",
    version: "v7.3",
    title: "Επίσημο Diathermiki.gr Logo στο Admin",
    type: "improvement",
    items: [
      "Το επάνω αριστερό brand block του admin χρησιμοποιεί πλέον το επίσημο λογότυπο Diathermiki.gr αντί για το προσωρινό generic σύμβολο",
      "Το logo διατηρεί το σωστό τετράγωνο aspect ratio, καθαρό λευκό υπόβαθρο και ευανάγνωστο wordmark χωρίς παραμόρφωση",
      "Ολόκληρο το brand block είναι προσβάσιμο link προς τη Γενική εικόνα, με σαφές accessible label και ορατό keyboard focus",
      "Σε αστοχία του εξωτερικού official asset υπάρχει ασφαλές local fallback ώστε η πλοήγηση να μη μένει με σπασμένη εικόνα",
      "Mock-only browser QA επιβεβαίωσε σωστή απόδοση στο desktop sidebar και στο mobile drawer χωρίς αλλαγή στα navigation items ή στα touch targets",
      "Πέρασαν TypeScript, scoped ESLint και production build χωρίς αλλαγή σε lead, συνεργάτη, ανάθεση ή ειδοποίηση",
    ],
  },
  {
    date: "4 Αυγούστου 2026",
    version: "v7.2",
    title: "Mini Page Readiness — Πληρότητα & Άμεση Προτεραιότητα",
    type: "improvement",
    items: [
      "Το /admin/partners δείχνει πλέον πόσες ενεργές mini pages είναι πλήρεις και πόσες χρειάζονται στοιχεία, με έναν server-calculated ορισμό πληρότητας",
      "Νέα φίλτρα εμφανίζουν πλήρεις, ελλιπείς, χωρίς εικόνα ή χωρίς περιγραφή mini pages χωρίς δεύτερο request ή αλλαγή δεδομένων",
      "Το clickable KPI ανοίγει άμεσα τους ενεργούς συνεργάτες με ελλείψεις και τους ταξινομεί με προτεραιότητα στα περισσότερα leads των τελευταίων 30 ημερών",
      "Κάθε desktop row και mobile card δείχνει αν λείπει εικόνα, περιγραφή, τηλέφωνο, τοποθεσία ή υπηρεσίες και οδηγεί απευθείας στην ασφαλή επεξεργασία συνεργάτη",
      "Το live snapshot πριν το release είχε 52 πλήρεις από 95 ενεργές mini pages, 43 χωρίς εικόνα και 39 χωρίς περιγραφή· κανείς ενεργός δεν είχε κενό τηλέφωνο, τοποθεσία ή υπηρεσίες",
      "Mock-only QA σε 1440px και 390px επιβεβαίωσε KPI→filter→priority flow, σωστά table/cards, μηδενικό horizontal overflow και 0 browser errors",
      "Πέρασαν TypeScript, scoped ESLint, production build, PHP lint και 142 PHP assertions χωρίς αλλαγή σε συνεργάτη, lead, ανάθεση ή ειδοποίηση",
    ],
  },
  {
    date: "4 Αυγούστου 2026",
    version: "v7.1",
    title: "Partner Settings Workspace — Ασφαλές Routing & Mobile Editing",
    type: "improvement",
    items: [
      "Το /admin/partners/edit/:id έγινε ολοκληρωμένο responsive workspace για routing, στοιχεία επικοινωνίας, υπηρεσίες, mini page και γεωγραφική κάλυψη",
      "Η σελίδα φορτώνει πλέον τον ακριβή συνεργάτη από purpose-specific endpoint και δεν μπορεί να εμφανίσει πρόωρα «δεν βρέθηκε» όσο φορτώνει ο γενικός κατάλογος",
      "Νέο admin/service-only GET/PATCH contract επιτρέπει μόνο τα γνωστά πεδία, κάνει server-side validation και χρησιμοποιεί prepared statements",
      "Η αποθήκευση μπορεί πλέον να καθαρίσει σωστά παλιά εικόνα ή περιγραφή mini page αντί να διατηρεί σιωπηλά τις προηγούμενες τιμές",
      "Προστέθηκαν πραγματικές ενδείξεις routing, email/SMS, portal και 30ήμερης ροής, με σαφή υπενθύμιση ότι τα secure lead links συνεχίζουν χωρίς login",
      "Ο Google χάρτης έχει loading/error state, ακριβείς συντεταγμένες, ελεγχόμενη ακτίνα 1–100 χλμ. και κάθε μετακίνηση pin ενεργοποιεί το unsaved-changes state",
      "Η φόρμα έχει inline server errors, visible dirty/saved state, προστασία πριν το browser exit και sticky mobile save χωρίς αλλαγή σε ιστορικά leads ή ειδοποιήσεις",
      "Mock-only QA σε 1440px και 390px επιβεβαίωσε πλήρες PATCH save flow, μηδενικό horizontal overflow και 0 application browser errors",
      "Πέρασαν TypeScript, scoped ESLint, production build, PHP lint και 137 PHP assertions χωρίς μεταβολή πραγματικού συνεργάτη ή lead",
    ],
  },
  {
    date: "4 Αυγούστου 2026",
    version: "v7.0",
    title: "Single Partner Control Center & Google Maps Recovery",
    type: "improvement",
    items: [
      "Το Google Maps key ήταν κανονικά αποθηκευμένο και έγκυρο· διορθώθηκε το frontend contract που δεν άνοιγε το data envelope του public config και το εμφάνιζε λανθασμένα ως απόν",
      "Το single partner page έγινε ενιαίο control center για ετοιμότητα routing, στοιχεία επικοινωνίας, pipeline, ειδοποιήσεις, mini page, follow-up και χρεώσεις",
      "Νέο admin/service-only typed API υπολογίζει τα KPIs από ολόκληρο το ιστορικό του συνεργάτη και όχι μόνο από τα 100 πιο πρόσφατα leads",
      "Τα statuses ενεργός, routing-ready, portal-ready και SMS suppression προκύπτουν από τα πραγματικά δεδομένα αντί για hardcoded ενδείξεις",
      "Προστέθηκαν φίλτρα περιόδου, 12μηνη ροή, stage distribution, notification health και operational priority score για τα leads που χρειάζονται follow-up",
      "Η καρτέλα Leads χρησιμοποιεί πλέον server pagination 25 εγγραφών, server search/filters και δεν εκτελεί N+1 requests για κάθε επαφή",
      "Οι καρτέλες SMS και Email απέκτησαν αξιόπιστα unique metrics, φίλτρα, pagination, mobile cards και desktop tables με direct links στα leads",
      "Η καρτέλα χρεώσεων χρησιμοποιεί πλέον πλήρες lightweight lead dataset, ώστε τα σύνολα να μην κόβονται στους 100 εγγραφές",
      "Mobile και desktop QA και στα πέντε tabs επιβεβαίωσε μηδενικό horizontal overflow, καθαρό console και touch targets τουλάχιστον 44px σε όλες τις ενέργειες",
      "Πέρασαν TypeScript, scoped ESLint, production build, PHP lint και 125 PHP assertions χωρίς fake lead, ανάθεση ή ειδοποίηση",
    ],
  },
  {
    date: "4 Αυγούστου 2026",
    version: "v6.9",
    title: "Χάρτης Κάλυψης — Πραγματικό Δίκτυο & Ασφαλή Pins",
    type: "improvement",
    items: [
      "Το /admin/partners/map έγινε ολοκληρωμένο workspace για τη γεωγραφική κάλυψη, την ετοιμότητα routing και τα leads που χρειάζονται χειροκίνητη ενέργεια",
      "Νέο admin-only map API επιστρέφει πλήρη aggregated εικόνα των unassigned leads και μόνο τα απολύτως απαραίτητα στοιχεία θέσης για τα pins, χωρίς ονόματα, τηλέφωνα, emails ή σχόλια",
      "Προστέθηκαν KPIs, αναζήτηση, φίλτρα κατάστασης, υπηρεσίας και ετοιμότητας, έλεγχος κύκλων κάλυψης και άμεση προσαρμογή του χάρτη στα ορατά σημεία",
      "Οι πληροφορίες συνεργατών και leads δημιουργούνται με ασφαλή DOM text nodes αντί για HTML interpolation, κλείνοντας τον κίνδυνο stored XSS στον χάρτη",
      "Όλα τα partner, coverage και unassigned overlays καθαρίζονται σωστά σε κάθε refresh ή αλλαγή φίλτρων, χωρίς διπλά pins και παλιά δεδομένα",
      "Σε κινητό ο χάρτης προηγείται της λίστας, τα σύνθετα φίλτρα ανοίγουν προαιρετικά και όλες οι βασικές ενέργειες παραμένουν προσβάσιμες με touch targets 44px",
      "Προστέθηκαν σαφή loading, retry, empty και missing-coordinate states, μαζί με direct links προς partner dashboard και Operations Inbox",
      "TypeScript, ESLint, production build και 110 PHP assertions πέρασαν χωρίς αλλαγή σε lead, assignment, partner ή notification",
    ],
  },
  {
    date: "4 Αυγούστου 2026",
    version: "v6.8",
    title: "Δίκτυο Συνεργατών — Ετοιμότητα & Κάλυψη",
    type: "improvement",
    items: [
      "Το /admin/partners έγινε επιχειρησιακό workspace που δείχνει ποιοι συνεργάτες είναι πραγματικά έτοιμοι να λάβουν leads",
      "Νέο admin-only directory API ενοποιεί στοιχεία συνεργατών, lifetime/30-day activity και service coverage σε μία κλήση χωρίς credential fields",
      "Η ετοιμότητα routing βασίζεται σε ενεργή κατάσταση, υπηρεσίες, συντεταγμένες και έγκυρη ακτίνα αντί για γενικό ενεργός/ανενεργός",
      "Προστέθηκαν φίλτρα κατάστασης, υπηρεσίας, ετοιμότητας, αδράνειας και SMS suppression, μαζί με αναζήτηση και έξι αξιόπιστες ταξινομήσεις",
      "Οι ενεργοί ανά υπηρεσία λειτουργούν ως άμεσα φίλτρα και αποκαλύπτουν τα πραγματικά κενά κάλυψης του δικτύου",
      "Το desktop χρησιμοποιεί πυκνό operational table, ενώ κινητό και card view έχουν πλήρη contact, coverage και activity εικόνα χωρίς κρυφές ενέργειες",
      "Η λίστα σελιδοποιείται ανά 12 συνεργάτες και όλα τα mobile actions διατηρούν touch target τουλάχιστον 44px",
      "Η οριστική διαγραφή είναι διαθέσιμη μόνο όταν ο συνεργάτης δεν έχει κανένα συνδεδεμένο lead· διαφορετικά προτείνεται απενεργοποίηση",
      "TypeScript, ESLint, production build και 101 PHP assertions πέρασαν χωρίς αλλαγή σε lead, assignment ή notification",
    ],
  },
  {
    date: "3 Αυγούστου 2026",
    version: "v6.7",
    title: "Κατανομή Αναθέσεων — Πραγματική Επιχειρησιακή Εικόνα",
    type: "improvement",
    items: [
      "Το /admin/leads/assignment έγινε responsive workspace για την τρέχουσα κατανομή των leads ανά περίοδο και υπηρεσία",
      "Νέο purpose-specific aggregated API επιστρέφει μόνο operational metrics, χωρίς ονόματα, τηλέφωνα ή emails leads",
      "Εμφανίζονται και οι ενεργοί service-compatible συνεργάτες που έχουν μηδενικό load στην επιλεγμένη περίοδο",
      "Αφαιρέθηκαν το τεχνητό Rejected = 0 και η παραπλανητική ταξινόμηση όλων των μη κλεισμένων leads ως pending",
      "Προστέθηκαν partner search, κατάσταση, ταξινόμηση, pagination, service coverage και σύνδεση με το Operations Inbox",
      "Το workspace παραμένει read-only και δεν εκτελεί bulk reassignment ή αυτόματη ανάθεση εκτός ακτίνας",
      "Καταργήθηκε ένα περιττό all-time metrics request που εκτελούνταν σε κάθε admin σελίδα",
      "Live QA σε desktop και κινητό επιβεβαίωσε σωστά φίλτρα, responsive cards/table, μηδενικό horizontal overflow και καθαρά runtime logs",
      "TypeScript, ESLint, production build και 95 PHP assertions πέρασαν χωρίς πραγματική ανάθεση ή ειδοποίηση",
    ],
  },
  {
    date: "3 Αυγούστου 2026",
    version: "v6.6",
    title: "Νέα Χειροκίνητη Επαφή — Ασφαλής Καταχώρηση",
    type: "improvement",
    items: [
      "Το /admin/leads/new έγινε ολοκληρωμένο responsive workspace με τέσσερα καθαρά βήματα και sticky έλεγχο πριν τη δημιουργία",
      "Οι προτάσεις συνεργατών λαμβάνουν υπόψη υπηρεσία, απόσταση, δηλωμένη ακτίνα και τρέχον πλήθος leads",
      "Η χειροκίνητη επιλογή εκτός ακτίνας επισημαίνεται χωρίς να αλλάζει ο κανόνας της αυτόματης ανάθεσης",
      "Διορθώθηκε η transaction εκκίνηση του endpoint ώστε lead, ανάθεση, operational alert και notification jobs να αποθηκεύονται ατομικά",
      "Ο διακόπτης ειδοποιήσεων ελέγχει πλέον πραγματικά τη durable queue· όταν είναι κλειστός δεν δημιουργείται notification job",
      "Οι χειροκίνητες αναθέσεις δέχονται μόνο ενεργό συνεργάτη που υποστηρίζει την επιλεγμένη υπηρεσία",
      "Το desktop admin sidebar μειώθηκε από 252px σε 236px, ενώ το mobile drawer και τα touch targets έμειναν αμετάβλητα",
      "TypeScript, ESLint, production build και 89 PHP assertions πέρασαν χωρίς fake production lead ή αποστολή ειδοποίησης",
    ],
  },
  {
    date: "3 Αυγούστου 2026",
    version: "v6.5",
    title: "Lineweb Updates — Νέα Σελίδα Εξέλιξης",
    type: "improvement",
    items: [
      "Νέο Lineweb Updates περιβάλλον με καθαρή χρονογραμμή, φίλτρα και σύνοψη των παραδόσεων",
      "Κάθε έκδοση εμφανίζει ημερομηνία και καταγεγραμμένη ώρα Ελλάδας (Europe/Athens)",
      "Προστέθηκε το ενιαίο Lineweb Digital Partner branding και άμεση πρόσβαση στα στοιχεία υποστήριξης",
      "Το admin sidebar έγινε πιο στενό, χωρίς αλλαγή στο mobile drawer ή στα touch targets",
      "Η σελίδα παραμένει γρήγορη και ευανάγνωστη σε κινητό, tablet και desktop",
    ],
  },
  {
    date: "3 Αυγούστου 2026",
    version: "v6.4",
    title: "Branded Email Sender & Deliverability 10/10",
    type: "system",
    items: [
      "✉️ Όλες οι ειδοποιήσεις αποστέλλονται πλέον ως Διαθερμική <leads@diathermiki.gr> αντί από εταιρική διεύθυνση της Lineweb",
      "🏷️ Τα subjects, τα password emails και τα footers έχουν ενιαίο τίτλο και branding Διαθερμικής",
      "🖼️ Το επίσημο logo φορτώνεται από σταθερό public asset μέσα σε partner, πελάτη, admin και password emails",
      "🔐 Το νέο mailbox χρησιμοποιεί authenticated SMTP με TLS, DKIM signing, SPF και DMARC alignment στο diathermiki.gr",
      "↩️ Οι απαντήσεις προωθούνται στο υφιστάμενο εταιρικό inbox της Διαθερμικής",
      "✅ Πραγματικό production-template test στο mail-tester πέτυχε 10/10, χωρίς blocklist ή broken links",
      "🛡️ Η αλλαγή ήταν subscription-scoped, με private rollback backup και χωρίς μεταβολή πραγματικού lead",
    ],
  },
  {
    date: "3 Αυγούστου 2026",
    version: "v6.3",
    title: "Επαφές — Νέα Καθημερινή Ουρά Εργασίας",
    type: "improvement",
    items: [
      "🎯 Η λίστα επαφών οργανώθηκε γύρω από τη σημερινή εργασία: νέα σήμερα, χωρίς συνεργάτη, χωρίς εξέλιξη 48 ωρών και διπλότυπα",
      "🔎 Αναζήτηση και προχωρημένα φίλτρα λειτουργούν με server pagination και διατηρούνται στο URL μετά από refresh",
      "📱 Τα lead cards, οι ενέργειες, τα φίλτρα και η σελιδοποίηση επανασχεδιάστηκαν για καθαρή χρήση σε κινητό, tablet και desktop",
      "⚡ Η λίστα χρησιμοποιεί κοινό query cache, keep-previous-data, skeleton loading, retry και χειροκίνητη ανανέωση χωρίς full-table download",
      "🕒 Οι ώρες των leads εμφανίζονται πλέον με τη σωστή ζώνη Ελλάδας αντί να ερμηνεύονται λανθασμένα ως UTC",
      "🧭 Η επανεκχώρηση μεταφέρθηκε στη σωστή ξεχωριστή σελίδα, ώστε το καθημερινό workspace να μην έχει διπλές ή επικίνδυνες λειτουργίες",
      "📨 Τα μαζικά follow-up email δεν στέλνονται πλέον με ένα click: προηγείται server-side preview και εμφανίζεται ο ακριβής αριθμός επιλέξιμων leads",
      "🗑️ Η οριστική διαγραφή βρίσκεται σε secondary menu και απαιτεί σαφή επιβεβαίωση με το όνομα της επαφής",
      "🛡️ Τα CSV επαφών εξουδετερώνουν spreadsheet formulas, ενώ admin auth και CSRF παραμένουν υποχρεωτικά",
      "✅ TypeScript, ESLint, PHP tests/build και responsive mock-only browser QA πέρασαν χωρίς production email ή μεταβολή lead",
    ],
  },
  {
    date: "3 Αυγούστου 2026",
    version: "v6.2",
    title: "Realtime Meta Intake — Ανάκτηση & Προστασία των Versioned Releases",
    type: "fix",
    items: [
      "🛠️ Διορθώθηκε το private Meta config resolution ώστε κάθε νέο versioned Plesk release να χρησιμοποιεί πάντα το σταθερό subscription config",
      "📥 Ανακτήθηκαν με ασφαλές idempotent replay 7 πραγματικά Net Billing leads που είχαν παραμείνει στο Lead Hub",
      "👥 4 από τα recovered leads ανατέθηκαν αυτόματα και 3 έμειναν ορατά χωρίς συνεργάτη επειδή δεν βρέθηκε κάλυψη",
      "📨 Όλες οι προβλεπόμενες ειδοποιήσεις των ανατεθειμένων leads στάλθηκαν μία φορά ανά κανάλι, χωρίς retries ή failures",
      "⚡ Νέο πραγματικό Net Billing lead μετά το hotfix έφτασε αυθόρμητα στο CRM σε 5 δευτερόλεπτα και επεξεργάστηκε σε 1 δευτερόλεπτο",
      "🧩 Επιβεβαιώθηκε ότι οι πολλαπλές φόρμες λειτουργούν κανονικά· το πρόβλημα δεν αφορούσε form routing ή Meta permissions",
      "🛡️ Προστέθηκε regression test για legacy και versioned Plesk docroots, με καθαρή Hub queue και μηδενικά duplicate Meta Lead IDs",
    ],
  },
  {
    date: "3 Αυγούστου 2026",
    version: "v6.1",
    title: "Operations Inbox — Από Λίστα Alerts σε Πραγματική Ουρά Εργασίας",
    type: "improvement",
    items: [
      "🎯 Νέο operational overview με ανοιχτές, κρίσιμες και αναληφθείσες εξαιρέσεις, παλαιότερο alert και ποσοστό κάλυψης",
      "🧭 Άμεσα φίλτρα για leads χωρίς συνεργάτη, SLA 48 ωρών, αποτυχίες email/SMS και Meta intake",
      "🔎 Server-side αναζήτηση και φίλτρα κατά κατάστασης, σοβαρότητας και κατηγορίας — χωρίς φόρτωση ολόκληρης της ουράς",
      "👤 Κάθε alert ξεχωρίζει καθαρά αν περιμένει ανάληψη ή βρίσκεται ήδη σε χειρισμό και ανοίγει απευθείας το αντίστοιχο lead",
      "📍 Η χειροκίνητη ανάθεση εμφανίζει ευανάγνωστα συνεργάτες, περιοχή, απόσταση και ακτίνα, με ρητή προειδοποίηση για επιλογή εκτός κάλυψης",
      "🛡️ Το χειροκίνητο κλείσιμο ζητά επιβεβαίωση και εξηγεί ότι το alert θα ανοίξει ξανά αν η πραγματική αιτία παραμένει",
      "⚡ Το server reconciliation περιορίζεται σε μία φορά ανά 30 δευτερόλεπτα ανά admin session· το κουμπί Ανανέωση κάνει ρητό πλήρη επανέλεγχο",
      "📱 Πλήρες responsive QA σε 390, 768 και 1440 px, χωρίς horizontal overflow ή console errors",
      "✅ TypeScript, ESLint, PHP lint και 73 contract assertions πέρασαν πριν από το production release",
    ],
  },
  {
    date: "3 Αυγούστου 2026",
    version: "v6.0",
    title: "Νέο Admin Workspace & Ακριβείς Αναφορές",
    type: "improvement",
    items: [
      "🧭 Νέο ενιαίο admin περιβάλλον με καθαρή πλοήγηση, contextual header και σωστή λειτουργία σε κινητό",
      "📊 Γενικές αναφορές, συνεργάτες, SMS και email απέκτησαν κοινή δομή, φίλτρα περιόδου και σαφή loading/error states",
      "👷 Τα σύνολα και οι εκτιμώμενες χρεώσεις συνεργατών υπολογίζονται πλέον από ολόκληρη τη βάση — όχι μόνο από τα 100 πρόσφατα leads",
      "⚖️ Η μετατροπή συνεργατών υπολογίζεται σταθμισμένα από σύνολο επιτυχιών / σύνολο leads",
      "📱 Τα μεγάλα tables γίνονται ευανάγνωστες κάρτες στο κινητό και όλες οι βασικές ενέργειες έχουν touch targets 44px+",
      "💬 Τα SMS reports ξεχωρίζουν πλέον την κατάσταση παρόχου από το click στο ασφαλές lead link — δεν παρουσιάζεται click ως read receipt",
      "✉️ Τα email reports μετρούν μοναδικές αποστολές, ανοίγματα και clicks από ολόκληρη την επιλεγμένη περίοδο, με search, pagination και CSV",
      "🔐 Τα νέα email statistics παραμένουν admin/service-only και δεν εμφανίζουν tracking IP ή user-agent",
      "🚨 Unassigned leads, SLA καθυστερήσεις και οριστικές αποτυχίες ειδοποιήσεων οδηγούν απευθείας στο Operations Inbox",
      "✅ Η έκδοση πέρασε TypeScript, PHP, browser QA σε desktop/mobile και 69 contract assertions πριν ανέβει live",
    ],
  },
  {
    date: "2 Αυγούστου 2026",
    version: "v5.8",
    title: "Ασφάλεια, Αξιόπιστες Ειδοποιήσεις & Operations Inbox",
    type: "system",
    items: [
      "🔐 Τα στοιχεία leads και συνεργατών δεν είναι πλέον προσβάσιμα χωρίς σωστό admin/partner session",
      "🔑 Οι συνεργάτες συνδέονται με προσωπικό κωδικό και ασφαλές email setup/reset 30 λεπτών",
      "📨 Email και SMS μπαίνουν σε ανθεκτική ουρά με retries και προστασία από διπλοαποστολές",
      "🌙 SMS που φτάνει 20:00–08:00 περιμένει αυτόματα μέχρι τις 08:00",
      "🚨 Νέο Operations Inbox για unassigned leads, αποτυχίες Meta/ειδοποιήσεων και SLA",
      "🧭 Η χειροκίνητη ανάθεση δείχνει συμβατούς συνεργάτες και απόσταση χωρίς αυθαίρετη ανάθεση εκτός ακτίνας",
      "⚡ Leads και reports φορτώνουν πλέον με pagination και server-side συγκεντρωτικά KPIs",
      "🛡️ Versioned production releases με DB/code backup, health checks και άμεσο rollback",
    ],
  },
  {
    date: "31 Ιουλίου 2026",
    version: "v5.7",
    title: "Meta Lead Hub — Realtime Υποδομή Χωρίς Διακοπή των Sheets",
    type: "feature",
    items: [
      "⚡ Νέα οθόνη **Meta Lead Hub** για όλες τις Meta φόρμες, το status και το mapping υπηρεσίας τους",
      "🛡️ Τα Google Sheets και το Apps Script συνεχίζουν κανονικά κατά τη μετάβαση",
      "  → Το κοινό Meta Lead ID εξασφαλίζει μία μόνο επαφή και μία μόνο ειδοποίηση συνεργάτη",
      "🔐 Το κεντρικό Hub προωθεί μόνο IDs με HMAC υπογραφή — όχι στοιχεία πελατών",
      "  → Τα προσωπικά στοιχεία ζητούνται απευθείας από τη Διαθερμική μόνο για εγκεκριμένη ενεργή φόρμα",
      "🚫 Νέες ή άγνωστες φόρμες εμφανίζονται αυτόματα αλλά μένουν ανενεργές μέχρι να ελεγχθούν",
      "📋 Queue με pending/retry/failed events χωρίς εμφάνιση προσωπικών δεδομένων",
      "ℹ️ Η υποδομή είναι live, αλλά η τελική σύνδεση Meta asset/token παραμένει ανενεργή μέχρι την ασφαλή εξουσιοδότηση",
    ],
  },
  {
    date: "29 Ιουλίου 2026",
    version: "v5.6",
    title: "Καθαρισμός: 13 Κρυμμένα Σφάλματα → 0",
    type: "system",
    items: [
      "🧹 Με τον σωστό έλεγχο κώδικα βρέθηκαν 13 σφάλματα που ήταν αόρατα για μήνες — διορθώθηκαν όλα",
      "🎯 **Προτεραιότητα leads**: ο κανόνας «αναλυτικό σχόλιο → +8 μονάδες» δεν εφαρμοζόταν ποτέ",
      "  → Το πεδίο σχολίων δεν περνούσε καθόλου στα δεδομένα της σελίδας",
      "  → Πλέον μετράει το σχόλιο του **πελάτη**, όχι τα στοιχεία καμπάνιας που έχουν όλα τα leads",
      "👁️ **Μηνύματα**: τα εικονίδια «Προβλήθηκε / Δεν προβλήθηκε» δεν εμφάνιζαν ποτέ επεξήγηση",
      "  → Το tooltip ήταν γραμμένο με τρόπο που το πρόγραμμα αγνοούσε· τώρα λειτουργεί",
      "🖼️ Τα εικονίδια σε επικεφαλίδες και κάρτες είχαν λάθος δήλωση τύπου",
      "📊 **Χρεώσεις συνεργάτη**: το φιλτράρισμα δούλευε κατά τύχη — διορθώθηκε ρητά",
      "🗺️ **Χάρτης**: οι ρυθμίσεις ζουμ ήταν σωστές αλλά αδήλωτες· ο έλεγχος τις απέρριπτε",
      "✅ Επαλήθευση σε ζωντανή σελίδα: εικονίδια σωστά, μηδέν σφάλματα στην κονσόλα",
    ],
  },
  {
    date: "29 Ιουλίου 2026",
    version: "v5.5",
    title: "Email Tracking & Ένα Εργαλείο Που Δεν Έλεγχε Τίποτα",
    type: "system",
    items: [
      "🔴 Ο έλεγχος κώδικα (typechecker) επέστρεφε «όλα καλά» ενώ **δεν έλεγχε κανένα αρχείο**",
      "  → Ρύθμιση του project τον έκανε να μεταγλωττίζει 0 αρχεία και να πετυχαίνει πάντα",
      "  → Με τη σωστή εντολή βρέθηκαν **13 πραγματικά σφάλματα**, ένα από τα οποία θα «έριχνε» σελίδα",
      "  → Εξηγεί γιατί πέρασαν απαρατήρητα τα λάθη ονομάτων πεδίων των προηγούμενων ημερών",
      "🐛 Η σελίδα Email είχε εφεδρικό ερώτημα που ζητούσε **και τις 13.131 εγγραφές μαζί**",
      "  → Ο server απαντούσε με σφάλμα 500· αφαιρέθηκε",
      "🔄 Ξανακατέβαζε ολόκληρο το αρχείο **σε κάθε ανανέωση δεδομένων** (ανά 5 λεπτά)",
      "  → Τώρα φορτώνει μία φορά",
      "⚡ Η αντιστοίχιση ονομάτων έκανε πάνω από 5 εκατομμύρια συγκρίσεις — πλέον στιγμιαία",
      "💬 Φαίνεται πλέον ότι τα στατιστικά αφορούν τις 2.000 πιο πρόσφατες καταγραφές",
      "  → Μια αναζήτηση χωρίς αποτέλεσμα δεν σημαίνει ότι το email δεν στάλθηκε",
      "🎨 Σωστό μήνυμα όταν δεν υπάρχουν καταγραφές, αντί για κόκκινο πλαίσιο σφάλματος",
    ],
  },
  {
    date: "29 Ιουλίου 2026",
    version: "v5.4",
    title: "Μηνύματα: Το Αρχείο Έδειχνε Ελάχιστα & Δεν Το Έλεγε",
    type: "fix",
    items: [
      "🔴 Η σελίδα φόρτωνε μόνο τα **300 πιο πρόσφατα** μηνύματα — χωρίς καμία ένδειξη",
      "  → SMS: 300 από 2.180 (14%) · Email: 300 από **13.131 (2,3%)**",
      "  → Ψάχνοντας email πελάτη έβλεπες «Δεν υπάρχουν εγγραφές» και συμπέραινες ότι δεν στάλθηκε",
      "  → Στην πραγματικότητα υπήρχε, απλώς ήταν παλαιότερο από τα 300 τελευταία",
      "✅ Το φίλτρο συνεργάτη τραβάει πλέον το **δικό του** ιστορικό από τον server (έως 500)",
      "  → Δοκιμάστηκε με συνεργάτη που έχει 555 email: πριν φαίνονταν ελάχιστα, τώρα 500 δικά του",
      "💬 Φαίνεται πλέον καθαρά πόσα εμφανίζονται, και το κενό μήνυμα εξηγεί ότι μπορεί να",
      "  υπάρχει παλαιότερη εγγραφή αντί να δηλώνει κατηγορηματικά ότι δεν υπάρχει τίποτα",
      "⚡ Η αναζήτηση έκανε πάνω από 1,3 εκατομμύρια συγκρίσεις σε κάθε πάτημα πλήκτρου",
      "  → Πλέον σταθερός χρόνος — η πληκτρολόγηση δεν κολλάει",
    ],
  },
  {
    date: "29 Ιουλίου 2026",
    version: "v5.3",
    title: "Συνεργάτες: Χρήσιμοι Δείκτες Αντί για Μηδενικά",
    type: "improvement",
    items: [
      "📊 Οι στήλες «Επιτυχίες» και «Rate» έδειχναν **μηδέν για σχεδόν κάθε συνεργάτη**",
      "  → Υπολογίζονταν από το στάδιο του lead, που δεν ενημερώνεται (3 κλεισμένες σε 2.655 leads)",
      "  → Ενεργοί συνεργάτες φαίνονταν αδρανείς ενώ έκλειναν κανονικά δουλειές",
      "✅ Αντικαταστάθηκαν με δείκτες που βασίζονται σε πραγματικά δεδομένα:",
      "  → **Τελ. 30 ημ.** — πόσα leads πήρε τον τελευταίο μήνα",
      "  → **Τελευταίο** — πόσες μέρες από το τελευταίο lead, με χρώμα (πράσινο/πορτοκαλί/κόκκινο)",
      "  → Η κάρτα «Επιτυχίες» στην κορυφή έγινε «Leads τελ. 30 ημερών»",
      "🔀 Νέες ταξινομήσεις: **«Πιο Πρόσφατη Δραστηριότητα»** και **«Χωρίς Lead Περισσότερο Καιρό»**",
      "  → Η δεύτερη δείχνει αμέσως ποιοι συνεργάτες έχουν σταματήσει να παίρνουν δουλειά",
      "🐛 Η ταξινόμηση «Νεότεροι» δεν έκανε απολύτως τίποτα — διάβαζε πεδίο που δεν υπήρχε στα δεδομένα",
    ],
  },
  {
    date: "29 Ιουλίου 2026",
    version: "v5.2",
    title: "⚡ Ταχύτητα: Η Σελίδα Leads Δεν Κολλάει Πια",
    type: "system",
    items: [
      "🔍 Η αιτία δεν ήταν οι κάρτες — ήταν ότι το σύστημα κατέβαζε ΟΛΟΚΛΗΡΟ τον πίνακα leads",
      "📦 Καμία συμπίεση δεν ήταν ενεργή: **2.789 KB → 378 KB** (7,4 φορές μικρότερο)",
      "⏱️ Χρόνος απόκρισης: **2,9 δευτερόλεπτα → 0,31** (9 φορές γρηγορότερα)",
      "🔄 Η αυτόματη ανανέωση γινόταν **κάθε 60 δευτερόλεπτα**",
      "  → Κάθε φορά κατέβαζε 2,8 MB και ξαναέφτιαχνε όλη τη σελίδα — εξ ου και το «πάγωμα» ανά λεπτό",
      "  → Σε μια 8ωρη βάρδια ξεπερνούσε το 1,3 GB κίνησης",
      "  → Τώρα κάθε 5 λεπτά, και **σταματά εντελώς όταν η καρτέλα δεν είναι ορατή**",
      "  → Μόλις επιστρέψεις στην καρτέλα, ανανεώνει αμέσως ώστε να βλέπεις τρέχοντα δεδομένα",
      "ℹ️ Το αρχείο της εφαρμογής (1,6 MB) δεν συμπιέζεται ακόμα — χρειάζεται ρύθμιση στον nginx",
      "  από το Plesk· οι ακριβείς οδηγίες καταγράφηκαν στον κώδικα",
    ],
  },
  {
    date: "29 Ιουλίου 2026",
    version: "v5.1",
    title: "Ανάθεση Lead: Σωστά Νούμερα & Προτεινόμενος Συνεργάτης",
    type: "fix",
    items: [
      "🔢 Στο dropdown ανάθεσης **κάθε συνεργάτης έδειχνε «0 leads»** — λάθος όνομα πεδίου στον κώδικα",
      "  → Το πλήθος leads είναι το κύριο κριτήριο του αυτόματου αλγορίθμου· έβλεπες μηδενικά",
      "  → Τώρα εμφανίζεται ο πραγματικός φόρτος κάθε συνεργάτη",
      "⭐ Η σειρά της λίστας διαφωνούσε με τον αλγόριθμο: ταξινομούσε μόνο κατά απόσταση,",
      "  ενώ το σύστημα επιλέγει πρώτα αυτόν με τα λιγότερα leads",
      "  → Ο πρώτος της λίστας δεν ήταν αυτός που θα διάλεγε το σύστημα· πλέον ταυτίζονται",
      "  → Ο προτεινόμενος σημειώνεται με αστεράκι",
      "💬 Μήνυμα όταν καμία ενεργή επιχείρηση δεν καλύπτει την υπηρεσία, αντί για κενή λίστα",
    ],
  },
  {
    date: "29 Ιουλίου 2026",
    version: "v5.0",
    title: "Λίστα Leads: Σελιδοποίηση & Ταχύτητα",
    type: "improvement",
    items: [
      "⚡ Η σελίδα φόρτωνε **και τα 2.700 leads ταυτόχρονα** — χιλιάδες κάρτες σε ένα render",
      "  → Πλέον 50 ανά σελίδα, με κουμπιά πλοήγησης (όπως έχει ήδη το portal των συνεργατών)",
      "🐌 Η τελευταία κάρτα εμφανιζόταν **66 δευτερόλεπτα** μετά το άνοιγμα της σελίδας",
      "  → Το εφέ εμφάνισης πολλαπλασιαζόταν επ' άπειρον με τον αριθμό των leads· τώρα έχει όριο",
      "📥 Διόρθωση εξαγωγής CSV — δεν κατέβαινε καθόλου σε Firefox και ενίοτε ακυρωνόταν σε Chrome",
      "  → Νέο μήνυμα διευκρινίζει ότι εξάγονται όλες οι φιλτραρισμένες επαφές, όχι μόνο η σελίδα",
      "🔢 Η ένδειξη «Εμφάνιση Χ από Ψ» έδειχνε λάθος αριθμό — τώρα δείχνει σελίδα, ταιριάσματα και σύνολο",
      "📊 Το «Ποσοστό επιτυχίας» δεν προβάλλεται πια ως πράσινος τίτλος",
      "  → Υπολογίζεται από το στάδιο του lead, που δεν ενημερώνεται· εμφανίζεται με σημείωση ότι",
      "    ο πραγματικός αριθμός είναι σαφώς υψηλότερος",
      "🔄 Η αλλαγή φίλτρου επιστρέφει στη σελίδα 1 αντί να αφήνει κενή προβολή",
    ],
  },
  {
    date: "29 Ιουλίου 2026",
    version: "v4.9",
    title: "Dashboard: Κάρτα Pipeline & Διόρθωση Νούμερων ανά Πηγή",
    type: "improvement",
    items: [
      "🎯 Νέα κάρτα «Κατάσταση Pipeline» — δείχνει πού βρίσκονται τα leads (Νέα / Εκκρεμότητα / Πληροφορίες / Επιτυχία)",
      "  → Ο υπολογισμός υπήρχε ήδη στον κώδικα αλλά δεν εμφανιζόταν ποτέ στην οθόνη",
      "  → Κλικ σε κάθε στάδιο ανοίγει τη λίστα leads φιλτραρισμένη σε αυτό",
      "⚠️ Προειδοποίηση όταν πάνω από το 70% των leads μένει σε «Νέο»",
      "  → Αυτή τη στιγμή είναι 2.548 από 2.655 (96%) — οι συνεργάτες δεν ενημερώνουν τα στάδια",
      "  → Σημαίνει ότι τα ποσοστά επιτυχίας που βλέπεις δεν είναι αξιόπιστα",
      "🔢 Διόρθωση «Leads ανά Πηγή»: οι κατηγορίες ήταν καρφωμένες σε τρεις, οπότε τα leads από",
      "  τηλέφωνο και demo δεν μετριόνταν πουθενά — 36 leads έλειπαν και τα ποσοστά δεν έβγαιναν",
      "  → Πλέον οι κατηγορίες προκύπτουν από τα πραγματικά δεδομένα, τίποτα δεν χάνεται",
      "🧹 Αφαιρέθηκαν αχρησιμοποίητα γραφήματα και εικονίδια που φόρτωναν χωρίς λόγο",
    ],
  },
  {
    date: "28 Ιουλίου 2026",
    version: "v4.8",
    title: "Η Φόρμα του Site Μοιράζει Πλέον Ίδια με τα Sheets",
    type: "fix",
    items: [
      "⚖️ Η φόρμα της ιστοσελίδας έδινε το lead στον **κοντινότερο** συνεργάτη, ενώ τα Sheets το δίνουν",
      "  σε αυτόν με τα **λιγότερα leads** — ο ίδιος πελάτης κατέληγε αλλού ανάλογα με το από πού ήρθε",
      "  → Πλέον χρησιμοποιείται ακριβώς η ίδια λογική και για τις δύο πηγές",
      "🔍 Αν ο πελάτης πληκτρολογούσε διεύθυνση χωρίς να τη διαλέξει από τη λίστα, το lead **δεν",
      "  ανατίθετο σε κανέναν** και έμενε στο κενό",
      "  → Τώρα ισχύει το ίδιο fallback με τα Sheets: αντιστοίχιση με ΤΚ και μετά δίκαιη κατανομή",
      "📱 Η ανάθεση γινόταν στον browser μετά την αποθήκευση — αν ο χρήστης έκλεινε την καρτέλα",
      "  (συχνό σε κίνηση από διαφημίσεις σε κινητό) το lead έμενε χωρίς συνεργάτη και χωρίς ειδοποίηση",
      "  → Όλα ολοκληρώνονται πλέον στον server, ανεξάρτητα από το τι κάνει ο επισκέπτης",
      "🛡️ Προστασία διπλής υποβολής: ίδιο τηλέφωνο μέσα σε 2 λεπτά δεν δημιουργεί δεύτερο lead",
      "  — ο συνεργάτης δεν χρεώνεται δύο φορές",
      "ℹ️ Η διαδρομή των Google Sheets δεν αγγίχτηκε καθόλου",
    ],
  },
  {
    date: "27 Ιουλίου 2026",
    version: "v4.7",
    title: "🔒 Κρίσιμη Διόρθωση Ασφαλείας: Διέρρεαν τα Credentials",
    type: "system",
    items: [
      "🔴 Οποιοσδήποτε στο internet μπορούσε να διαβάσει όλα τα μυστικά του συστήματος — χωρίς κωδικό",
      "  → Διέρρεαν: Twilio token, Google Maps API key, κωδικός SMTP, κωδικός εγγραφής συνεργατών",
      "  → Και μπορούσε να τα αλλάξει κιόλας",
      "  → Επιβεβαιώθηκε ζωντανά πριν τη διόρθωση με ανώνυμο αίτημα",
      "✅ Πλέον οι ρυθμίσεις απαιτούν σύνδεση διαχειριστή",
      "  → Χωρίς σύνδεση επιστρέφονται μόνο τα δημόσια πεδία (Pixel ID, Google Analytics ID)",
      "  → Κάθε απόπειρα εγγραφής απορρίπτεται με 403",
      "⚠️ Συνιστάται αλλαγή των κωδικών Twilio, Google Maps και SMTP — ήταν εκτεθειμένοι",
      "ℹ️ Καμία εσωτερική λειτουργία δεν επηρεάστηκε — SMS, email και geocoding δουλεύουν κανονικά",
    ],
  },
  {
    date: "27 Ιουλίου 2026",
    version: "v4.6",
    title: "Facebook Pixel & Conversions API",
    type: "feature",
    items: [
      "📊 Σύνδεση με Meta Conversions API — οι μετατροπές στέλνονται και από τον server, όχι μόνο από τον browser",
      "  → Μετρώνται πλέον και όσοι έχουν ad blocker ή αυστηρές ρυθμίσεις απορρήτου",
      "  → Pixel και CAPI μοιράζονται κοινό αναγνωριστικό, ώστε η μετατροπή να μετράει μία φορά",
      "🔐 Ο browser στέλνει μόνο το ID του lead — τα προσωπικά στοιχεία διαβάζονται από τη βάση και",
      "  κρυπτογραφούνται στον server, όπως απαιτεί το Meta",
      "🛡️ Δέχεται μόνο leads των τελευταίων 30 λεπτών και κάθε γεγονός μία φορά — αποτρέπει πλαστά events",
      "⚙️ Νέα πεδία στις Ρυθμίσεις → Παρακολούθηση: Access Token και Test Event Code",
      "🐛 Διόρθωση: η σελίδα έστελνε δεύτερο event χωρίς αναγνωριστικό — κάθε μετατροπή θα μετριόταν διπλά",
      "ℹ️ Όσο δεν έχει συμπληρωθεί το token, το CAPI παραμένει ανενεργό και δεν επηρεάζει τίποτα",
    ],
  },
  {
    date: "27 Ιουλίου 2026",
    version: "v4.5",
    title: "Φόρμα σε Κινητό: Σταθερό Κουμπί Αποστολής & Ένδειξη Προόδου",
    type: "improvement",
    items: [
      "📱 Η φόρμα στο κινητό είναι πάνω από 3 οθόνες — ο επισκέπτης έπρεπε να φτάσει ως το τέλος για να στείλει",
      "  → Νέα σταθερή μπάρα στο κάτω μέρος: το κουμπί «Λήψη δωρεάν προσφοράς» είναι πάντα προσβάσιμο",
      "  → Με μπάρα προόδου: «Συμπληρώθηκαν 3 από 5» και ποσοστό — δίνει κίνητρο για ολοκλήρωση",
      "  → Όταν συμπληρωθούν όλα εμφανίζεται «Όλα έτοιμα — στείλτε το αίτημα»",
      "  → Σέβεται το safe area του iPhone ώστε να μην κρύβεται πίσω από τη μπάρα πλοήγησης",
      "🎯 Οι κάρτες υπηρεσιών μίκρυναν στο κινητό (124px → 107px) — λιγότερο σκρολάρισμα πριν τα πεδία",
      "🏷️ Τα σήματα εμπιστοσύνης (Άμεση απόκριση / Ασφαλή δεδομένα / Δωρεάν εκτίμηση) στοιβάζονταν σε 3 σειρές",
      "  → Τώρα σε μία σειρά με εικονίδιο πάνω από το κείμενο — κερδίζονται περίπου 100px πάνω από τη φόρμα",
      "🖥️ Καμία αλλαγή στην εμφάνιση από υπολογιστή — όλα τα παραπάνω ισχύουν μόνο σε κινητό",
    ],
  },
  {
    date: "27 Ιουλίου 2026",
    version: "v4.4",
    title: "Φόρμα Ιστοσελίδας: Έλεγχος Στοιχείων & Μέτρηση Προέλευσης",
    type: "feature",
    items: [
      "🎯 Η φόρμα καταγράφει πλέον από πού ήρθε ο επισκέπτης — utm_campaign, utm_source, fbclid, gclid, variant",
      "  → Τα leads του site δεν μετριούνται πια λανθασμένα ως «Facebook Ads» (η βάση έβαζε αυτή την προεπιλογή)",
      "  → Η πηγή γράφεται ως «Web» και η καμπάνια στη στήλη Καμπάνια — δουλεύουν αυτόματα τα φίλτρα στη σελίδα Leads",
      "  → Αυτό είναι που κάνει μετρήσιμο το τεστ: διαφήμιση με φόρμα Facebook vs διαφήμιση προς την ιστοσελίδα",
      "📞 Έλεγχος τηλεφώνου πριν την υποβολή — 10 ψηφία, ξεκινά με 69 (κινητό) ή 2 (σταθερό)",
      "  → Δέχεται +30, 0030, κενά, παύλες και διεθνείς αριθμούς για πελάτες εξωτερικού",
      "  → Ένα λάθος τηλέφωνο σήμαινε άχρηστο lead που χρεωνόταν κανονικά 3€ στον συνεργάτη",
      "📮 Έλεγχος ΤΚ — δέχεται μόνο 5 ψηφία, με αυτόματο καθάρισμα ό,τι δεν είναι αριθμός",
      "💬 Τα μηνύματα λάθους εμφανίζονται κάτω από το κάθε πεδίο και η σελίδα κυλάει στο πρώτο πρόβλημα",
      "📱 Autocomplete στα πεδία (όνομα, τηλέφωνο, ΤΚ) — το κινητό συμπληρώνει αυτόματα",
      "🧹 Το «Συμπληρώστε στα σχόλια» εμφανιζόταν κάτω από όλες τις υπηρεσίες — τώρα μόνο στο «Άλλο» που το χρειάζεται",
    ],
  },
  {
    date: "27 Ιουλίου 2026",
    version: "v4.3",
    title: "Καθαρότερη Προβολή Lead & Εντοπισμός Διπλοτύπων",
    type: "improvement",
    items: [
      "📋 Lead Details: τα στοιχεία καμπάνιας εμφανίζονταν ως ένα μπερδεμένο κείμενο μέσα στα «Σχόλια»",
      "  → Τώρα ξεχωριστό panel «Στοιχεία Καμπάνιας»: Καμπάνια, Φόρμα, Διαφήμιση σε δικές τους γραμμές",
      "  → Badge «Πληρωμένη διαφήμιση» ή «Οργανικό» — φαίνεται αμέσως αν το lead κόστισε",
      "  → Τα πραγματικά σχόλια του πελάτη εμφανίζονται πλέον μόνα τους",
      "⚠️ Οι προειδοποιήσεις (πιθανό διπλότυπο, αποτυχία geocoding) βγήκαν σε ξεχωριστά πορτοκαλί πλαίσια",
      "  → Το διπλότυπο έχει κουμπί «Δες το» που ανοίγει κατευθείαν το άλλο lead με το ίδιο τηλέφωνο",
      "📋 Κουμπί αντιγραφής τηλεφώνου δίπλα στον αριθμό",
      "🔍 Νέο φίλτρο «Διπλότυπα» στη λίστα Leads — δείχνει μόνο όσα έχουν τηλέφωνο που εμφανίζεται πάνω από μία φορά",
      "  → Ταξινομημένα ώστε τα ίδια τηλέφωνα να είναι το ένα κάτω από το άλλο για εύκολη σύγκριση",
      "👷 Partner Portal: οι συνεργάτες έβλεπαν τα στοιχεία καμπάνιας σαν να ήταν σχόλιο του πελάτη — πλέον κρύβονται",
      "👷 Partner Portal: το φίλτρο υπηρεσίας έδειχνε ωμά ονόματα (αντλίεςΘερμότητας) — τώρα κανονικά ελληνικά",
      "👷 Partner Portal: καλύτερο μήνυμα όταν δεν υπάρχουν leads — ξεχωρίζει «δεν έχετε ακόμη» από «κανένα με αυτά τα φίλτρα»",
    ],
  },
  {
    date: "27 Ιουλίου 2026",
    version: "v4.2",
    title: "⚠️ Κρίσιμη Διόρθωση: Τα Ηλιακά Πήγαιναν σε Συνεργάτες Αντλιών",
    type: "fix",
    items: [
      "🔴 Στην καμπάνια «Αντλία - Ηλιακό», όποιος επέλεγε «ηλιακός θερμοσίφωνας» καταχωρούνταν ως αντλία θερμότητας",
      "  → Αιτία: το σύστημα έψαχνε τη λέξη «αντλί» και μέσα στον τίτλο της καμπάνιας — και η καμπάνια λέγεται «( Αντλία - Ηλιακό )»",
      "  → Έτσι ο τίτλος της διαφήμισης υπερίσχυε της επιλογής του ίδιου του πελάτη",
      "  → Στην πράξη περίπου 500 leads ηλιακών από τον Μάρτιο στάλθηκαν σε λάθος ειδικότητα συνεργατών",
      "✅ Πλέον η επιλογή του πελάτη υπερισχύει πάντα — ο τίτλος της καμπάνιας χρησιμοποιείται μόνο αν ο πελάτης δεν έχει επιλέξει τίποτα",
      "🧪 Καλύφθηκε με 13 δοκιμές με τις πραγματικές τιμές των Sheets πριν ανέβει",
      "ℹ️ Ισχύει για τα νέα leads — τα ήδη καταχωρημένα παρέμειναν ως έχουν κατόπιν απόφασης",
      "🔍 Ελέγχθηκαν και τα 3 Google Sheets: κώδικας, κλειδιά και triggers — όλα σωστά και ενεργά",
    ],
  },
  {
    date: "3 Ιουλίου 2026",
    version: "v4.1",
    title: "Διόρθωση Ρυθμίσεων Συνεργάτη & Καθαρισμός",
    type: "fix",
    items: [
      "🔴 Οι ρυθμίσεις στο Partner Portal δεν αποθηκεύονταν ποτέ — κάθε προσπάθεια απέτυχε σιωπηλά",
      "  → Το σύστημα έγραφε σε στήλες που δεν υπάρχουν στη βάση (radius_km, email_opt_out)",
      "  → Πλέον γράφει στη σωστή στήλη ακτίνας — αυτή που διαβάζει και η αυτόματη ανάθεση leads",
      "🧹 Αφαιρέθηκε ο διακόπτης «Απενεργοποίηση Email Ειδοποιήσεων» — δεν έκανε απολύτως τίποτα",
      "🔒 Διαγράφηκαν 5 παλιά scripts εγκατάστασης/δοκιμών από τον server",
    ],
  },
  {
    date: "28 Απριλίου 2026",
    version: "v4.0",
    title: "Σελίδα Συνεργατών, Dashboard & Προστασία Φόρμας",
    type: "feature",
    items: [
      "🔀 Σελίδα Συνεργατών: ταξινόμηση με 6 κριτήρια (περισσότερα leads, επιτυχίες, χρέωση, όνομα, νεότεροι)",
      "🔲 Εναλλαγή προβολής Κάρτες / Συμπτυγμένη λίστα — η λίστα δείχνει όλους τους δείκτες μαζί για σύγκριση",
      "💶 Badge συνολικής χρέωσης σε κάθε κάρτα συνεργάτη + 5η κάρτα «Συνολικά Έσοδα» στην κορυφή",
      "📊 Partner Dashboard: νέοι δείκτες — Συνολικά Έσοδα, Τελευταία Ενέργεια, Μ.Ο. χρόνου κλεισίματος",
      "🗂️ Τα tabs μειώθηκαν από 6 σε 5 — το «Timeline» έφυγε καθώς τα ίδια δεδομένα φαίνονται στα SMS/Email",
      "📐 Το Overview ξανασχεδιάστηκε για λιγότερο σκρολάρισμα",
      "💾 Νέα Φόρμα Lead: προειδοποίηση όταν φεύγεις με μισοσυμπληρωμένη φόρμα",
      "  → Αυτόματη αποθήκευση προσχεδίου για 24 ώρες — επιστρέφοντας βρίσκεις ό,τι είχες γράψει",
      "  → Το κουμπί «Πίσω» επιστρέφει εκεί απ' όπου ήρθες αντί για σταθερή σελίδα",
    ],
  },
  {
    date: "27 Απριλίου 2026",
    version: "v3.9",
    title: "Σταθερότητα Email & Ταχύτητα Φόρτωσης",
    type: "system",
    items: [
      "🐛 Διόρθωση σφάλματος 500 στη δοκιμαστική αποστολή email",
      "⚡ Η λίστα leads έκανε έως 97 ταυτόχρονα αιτήματα στη βάση — πλέον μόλις 2",
      "  → Αισθητά ταχύτερο άνοιγμα σε λογαριασμούς με πολλά leads",
      "👁️ Προεπισκόπηση προτύπων email στις Ρυθμίσεις (Συνεργάτη / Πελάτη / Admin)",
      "🏷️ Στατιστικά Email: νέα στήλη «Τύπος» με χρωματιστά badges ανά παραλήπτη",
      "🔎 Ολοκληρωμένος έλεγχος ασφαλείας σε 24 σελίδες, 39 endpoints και 9 πίνακες βάσης",
    ],
  },
  {
    date: "17 Απριλίου 2026",
    version: "v3.8",
    title: "Σημειώσεις, Manual Leads, Email Testing & Live Suggestions",
    type: "feature",
    items: [
      "📝 Σημειώσεις (Notes) ανά lead — timeline view με χρονολογίες + author badges (admin/partner διαφορετικό στυλ)",
      "  → Εμφανίζεται στο Partner Portal (/lead/:id) κάτω από τα στοιχεία",
      "  → Νέο tab 'Σημειώσεις' στο Admin Lead Details (/admin/lead/:id)",
      "🎯 Νέα σελίδα χειροκίνητης δημιουργίας leads (/admin/leads/new)",
      "  → Φόρμα με όλα τα πεδία (όνομα*, τηλέφωνο*, email, διεύθυνση, ΤΚ, πόλη, υπηρεσία*, χρονοδιάγραμμα, πηγή)",
      "  → Toggle 'Ειδοποιήσεις' — στέλνει SMS+Email σε συνεργάτη + confirmation email/SMS στον πελάτη",
      "  → Auto-geocoding τοποθεσίας + auto-matching συνεργάτη βάσει περιοχής/υπηρεσίας",
      "  → Μετά την δημιουργία → redirect στο lead details για άμεση προβολή",
      "✨ Live Partner Suggestions — καθώς επιλέγεις υπηρεσία, εμφανίζονται προτεινόμενοι συνεργάτες με:",
      "  → Φιλτράρισμα: μόνο συνεργάτες που προσφέρουν την επιλεγμένη υπηρεσία",
      "  → Κάρτες με: όνομα, υπηρεσίες (badges), τηλέφωνο",
      "  → Κλικ για επιλογή ή 'Αυτόματη ανάθεση'",
      "📧 Logo Διαθερμικής σε όλα τα emails (πάνω από τον τίτλο) — branded με 72px rounded square",
      "🧪 Νέα σελίδα Email Testing (/admin/settings/email-test)",
      "  → Δοκιμή όλων των email templates (Partner Notification, Admin Unassigned, Lead Confirmation, Follow-up)",
      "  → Με πλαστά δεδομένα (Γιώργος Παπαδόπουλος, κτλ.)",
      "  → Εμφανίζει θέμα email + δοκιμαστικά δεδομένα + κουμπί 'Στείλε Test'",
      "🔧 Πηγές (Source) σε manual leads — απλοποιημένη λίστα: Τηλέφωνο, Website, Email, Άλλο",
      "📱 Backend: Νέο API endpoint /api/create-manual-lead.php (admin authenticated)",
      "📱 Frontend: Νέο API endpoint /api/lead-notes.php (GET/POST/DELETE notes)",
      "📱 Frontend: Νέο API endpoint /api/send-test-email.php (admin authenticated)",
      "💾 Νέος πίνακας DB: lead_notes (id, lead_id, author_type, author_name, note, created_at, updated_at)",
    ],
  },
  {
    date: "31 Μαρτίου 2026",
    version: "v3.7",
    title: "Σελίδα Χρεώσεων Συνεργατών",
    type: "feature",
    items: [
      "Νέα σελίδα /admin/billing — συγκεντρωτικές χρεώσεις ανά συνεργάτη (3€/lead)",
      "Φίλτρα περιόδου: Εβδομάδα / Μήνας / Τρίμηνο / Έτος / Όλα",
      "4 stat cards: Σύνολο Leads, Συνολικό Ποσό, Ενεργοί Συνεργάτες, Μ.Ο.",
      "Πίνακας με όλους τους συνεργάτες, leads και χρέωση — με εξαγωγή CSV",
      "Tab 'Χρεώσεις' σε κάθε partner dashboard — ατομική ανάλυση με bar chart + πίνακας leads",
      "Εικονίδιο Euro στο sidebar μεταξύ Μηνυμάτων και Αναφορών",
    ],
  },
  {
    date: "31 Μαρτίου 2026",
    version: "v3.6",
    title: "Διορθώσεις & Βελτιώσεις Μηνυμάτων",
    type: "fix",
    items: [
      "Διόρθωση geocoding: ΤΚ πλέον αναζητείται με χώρα (Greece) + components=country:GR — αποφεύγεται εσφαλμένη αντιστοίχηση σε Αθήνα κέντρο αντί για περιφέρεια (π.χ. Λαύριο 19500)",
      "Αποτέλεσμα: leads πλέον ανατίθενται στον σωστό γεωγραφικά συνεργάτη — ο τελευταίος fallback δεν αγνοεί την ακτίνα",
      "Σελίδα Μηνυμάτων: Eye/EyeOff indicator — φαίνεται αν ο συνεργάτης άνοιξε το link",
      "Σελίδα Μηνυμάτων: service badge + 'Άμεσα' badge σε κάθε SMS row",
      "Σελίδα Μηνυμάτων: Email Αρχείο ομαδοποίηση ανά ημέρα (Σήμερα/Χθες/Παλαιότερα) + φίλτρο συνεργάτη",
      "Σελίδα Μηνυμάτων: Follow-up cards με service/stage badge + κουμπί 'Νέο SMS' υπενθύμισης",
      "Σελίδα Μηνυμάτων: stat card 'SMS Προβλήθηκαν %' αντί αποτυχιών",
      "Διόρθωση timezone: timestamps SMS/Email εμφανίζονται πλέον σωστά (UTC→τοπική ώρα)",
      "Στατιστικά SMS: διόρθωση 500 error (ambiguous column 'created_at' στο byPartner query)",
    ],
  },
  {
    date: "26 Μαρτίου 2026",
    version: "v3.5",
    title: "UI Βελτιώσεις & Νέα Εργαλεία",
    type: "feature",
    items: [
      "Dashboard: κόκκινο banner όταν υπάρχουν leads χωρίς ανάθεση — με κουμπί \"Δες τα\"",
      "Leads: κουμπί εξαγωγής CSV με τα τρέχοντα φίλτρα (π.χ. μόνο unassigned, μόνο αντλίες κτλ.)",
      "Lead Details: πηγή lead εμφανίζεται ως badge — 📊 Sheets, 📣 FB Ads, 🌐 Web",
      "Lead Details: dropdown ανάθεσης εμφανίζεται πάντα (ακόμα και αν έχει ήδη συνεργάτη) — για επανανάθεση",
      "Lead Details: στο dropdown φαίνονται km απόσταση + αριθμός leads ανά συνεργάτη",
      "Μηνύματα: κουμπί \"Ξαναστείλε\" για αποτυχημένα SMS",
      "Partner Dashboard: νέο tab \"Timeline\" — SMS και Email events σε μία κοινή ροή χρόνου",
      "Χάρτης Συνεργατών: κίτρινες καρφίτσες για αδιάθετα leads που έχουν τοποθεσία",
      "SMS logs: μεταφέρθηκαν σε MySQL (αντί για JSON αρχείο) — πλήρη δεδομένα παράδοσης",
    ],
  },
  {
    date: "25 Μαρτίου 2026",
    version: "v3.4",
    title: "3ο Sheet: Net Billing (Φωτοβολταϊκά)",
    type: "feature",
    items: [
      "Σύνδεση 3ου Google Sheet (Net Billing) με αυτόματη εισαγωγή leads",
      "Υπηρεσία: Φωτοβολταϊκά — αυτόματη ανάθεση σε συνεργάτες φωτοβολταϊκών",
      "Επεξεργάστηκαν 41 παλιές εγγραφές (από γραμμή 832) με fixNow()",
      "Trigger: On change → onSheetChange — λειτουργεί αυτόματα για κάθε νέα εγγραφή",
    ],
  },
  {
    date: "25 Μαρτίου 2026",
    version: "v3.3",
    title: "Ηλιακό Sheet & Βελτιώσεις Pipeline",
    type: "improvement",
    items: [
      "Νέο Sheet για Αντλία & Ηλιακό — ξαναφτιάχτηκε με σωστή δομή στηλών",
      "Χαρτογράφηση υπηρεσιών: \"και τα 2\" → Αντλίες Θερμότητας, \"ηλιακός\" → Ηλιακά",
      "Διόρθωση timezone: τα leads από Facebook αποθηκεύονται πλέον σε UTC (αντί ντόπια ώρα)",
      "Ειδοποιήσεις για αδιάθετα leads: πηγαίνουν σε ΟΛΑ τα ενεργά admin emails (όχι μόνο ένα)",
    ],
  },
  {
    date: "24 Μαρτίου 2026",
    version: "v3.2",
    title: "Google Sheets Αυτοματισμός (Bosch + Αντλία & Ηλιακό)",
    type: "feature",
    items: [
      "Σύνδεση 1ου Sheet (Αντλία & Ηλιακό) — multi-service, διαβάζει ποιο προϊόν επέλεξε ο πελάτης",
      "Σύνδεση 2ου Sheet (Bosch Αντλίες) — single-service, πάντα αντλίες θερμότητας",
      "Αυτόματη γεωκωδικοποίηση με Google Maps API (πόλη + ΤΚ → lat/lng)",
      "Αυτόματη ανάθεση συνεργάτη βάσει υπηρεσίας, ακτίνας και αριθμού leads (load balancing)",
      "SMS στον συνεργάτη + email με στοιχεία lead",
      "SMS επιβεβαίωσης στον πελάτη με link mini-page",
    ],
  },
  {
    date: "23 Μαρτίου 2026",
    version: "v3.1",
    title: "Σελίδα Μηνυμάτων & SMS/Email Tracking",
    type: "improvement",
    items: [
      "Πλήρης ανανέωση σελίδας Μηνυμάτων: 4 tabs (Αδιάθετα, SMS, Email, Follow-up)",
      "SMS logs από MySQL αντί από JSON αρχείο — αξιόπιστα δεδομένα",
      "Per-partner SMS metrics: Παραδόθηκε/Απέτυχε/Κλικ ανά lead",
      "Email tracking: άνοιγμα, κλικ, bounce — ανά συνεργάτη",
      "Διόρθωση 401 errors στα logs endpoints — CSRF token αντί API key",
    ],
  },
  {
    date: "20 Μαρτίου 2026",
    version: "v3.0",
    title: "Νέο Design System & Admin UI",
    type: "improvement",
    items: [
      "Πλήρης ανανέωση admin UI — νέο design system με Tailwind",
      "Νέο sidebar με submenus, active states, mobile hamburger",
      "Dashboard με γραφήματα, leads ανά πηγή, καμπάνια breakdown, partner performance",
      "Partner health score: χρωματική ένδειξη (🟢 καλό / 🟡 μέτριο / 🔴 χαμηλό)",
      "Lead Details με hero card, tabs (Στοιχεία / Επικοινωνία / Ιστορικό)",
    ],
  },
  {
    date: "15 Μαρτίου 2026",
    version: "v2.0",
    title: "MySQL + PHP Backend",
    type: "system",
    items: [
      "Μετάβαση από Supabase σε MySQL/PHP backend",
      "Δικό μας authentication με sessions και CSRF tokens",
      "API endpoints για leads, partners, SMS/email logs",
      "sms_opt_out: οι συνεργάτες που δεν θέλουν SMS δεν λαμβάνουν",
      "Ανάπτυξη σε ιδιόκτητο server (Plesk) — staging: leads.lineweb.gr, production: app.diathermiki.gr",
    ],
  },
];

type UpdateFilter = "all" | ChangelogEntry["type"];

const FILTERS: Array<{ value: UpdateFilter; label: string }> = [
  { value: "all", label: "Όλα" },
  { value: "feature", label: "Νέα" },
  { value: "improvement", label: "Βελτιώσεις" },
  { value: "fix", label: "Διορθώσεις" },
  { value: "system", label: "Σύστημα" },
];

const TYPE_CONFIG = {
  feature: {
    label: "Νέα δυνατότητα",
    icon: Sparkles,
    badgeClass: "border-red-200 bg-red-50 text-red-700",
    dotClass: "bg-red-500",
  },
  improvement: {
    label: "Βελτίωση",
    icon: Zap,
    badgeClass: "border-sky-200 bg-sky-50 text-sky-700",
    dotClass: "bg-sky-500",
  },
  fix: {
    label: "Διόρθωση",
    icon: Wrench,
    badgeClass: "border-amber-200 bg-amber-50 text-amber-700",
    dotClass: "bg-amber-500",
  },
  system: {
    label: "Σύστημα",
    icon: Database,
    badgeClass: "border-violet-200 bg-violet-50 text-violet-700",
    dotClass: "bg-violet-500",
  },
} satisfies Record<ChangelogEntry["type"], {
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  badgeClass: string;
  dotClass: string;
}>;

// Earliest verifiable publication of each update (Git history for legacy entries,
// production release time for new entries) so the UI never invents an upload time.
const PUBLISHED_AT_BY_VERSION: Record<string, string> = {
  "v8.13": "2026-09-09T13:04:49+03:00",
  "v8.12": "2026-09-09T12:08:46+03:00",
  "v8.11": "2026-09-07T13:39:31+03:00",
  "v8.10": "2026-09-07T13:23:07+03:00",
  "v8.9": "2026-09-03T20:56:58+03:00",
  "v8.8": "2026-09-03T12:50:00+03:00",
  "v8.7": "2026-09-03T12:16:12+03:00",
  "v8.6": "2026-09-03T10:34:00+03:00",
  "v8.4": "2026-09-01T13:17:22+03:00",
  "v8.3": "2026-08-29T20:53:14+03:00",
  "v8.2": "2026-08-29T14:20:03+03:00",
  "v8.1": "2026-08-29T14:03:01+03:00",
  "v8.0": "2026-08-29T13:31:36+03:00",
  "v7.9": "2026-08-29T13:03:59+03:00",
  "v7.8": "2026-08-25T14:55:07+03:00",
  "v7.7": "2026-08-20T14:10:42+03:00",
  "v7.6": "2026-08-05T14:41:05+03:00",
  "v7.5": "2026-08-05T14:09:26+03:00",
  "v7.4": "2026-08-05T12:55:10+03:00",
  "v7.3": "2026-08-04T17:47:45+03:00",
  "v7.2": "2026-08-04T17:28:08+03:00",
  "v7.1": "2026-08-04T16:32:27+03:00",
  "v7.0": "2026-08-04T15:42:11+03:00",
  "v6.9": "2026-08-04T14:46:44+03:00",
  "v6.8": "2026-08-04T13:49:18+03:00",
  "v6.7": "2026-08-03T22:40:48+03:00",
  "v6.6": "2026-08-03T22:13:28+03:00",
  "v6.5": "2026-08-03T21:30:09+03:00",
  "v6.4": "2026-08-03T21:19:40+03:00",
  "v6.3": "2026-08-03T17:33:41+03:00",
  "v6.2": "2026-08-03T16:41:01+03:00",
  "v6.1": "2026-08-03T15:53:46+03:00",
  "v6.0": "2026-08-03T15:07:19+03:00",
  "v5.8": "2026-08-02T22:13:13+03:00",
  "v5.7": "2026-08-02T22:13:13+03:00",
  "v5.6": "2026-07-29T15:57:00+03:00",
  "v5.5": "2026-07-29T15:37:40+03:00",
  "v5.4": "2026-07-29T15:21:23+03:00",
  "v5.3": "2026-07-29T15:10:10+03:00",
  "v5.2": "2026-07-29T13:40:46+03:00",
  "v5.1": "2026-07-29T13:32:17+03:00",
  "v5.0": "2026-07-29T13:22:30+03:00",
  "v4.9": "2026-07-29T13:00:46+03:00",
  "v4.8": "2026-07-28T13:35:05+03:00",
  "v4.7": "2026-07-28T12:13:30+03:00",
  "v4.6": "2026-07-28T12:13:30+03:00",
  "v4.5": "2026-07-28T11:47:16+03:00",
  "v4.4": "2026-07-27T17:20:36+03:00",
  "v4.3": "2026-07-27T17:20:36+03:00",
  "v4.2": "2026-07-27T17:20:36+03:00",
  "v4.1": "2026-07-27T17:20:36+03:00",
  "v4.0": "2026-07-27T17:20:36+03:00",
  "v3.9": "2026-07-27T17:20:36+03:00",
  "v3.8": "2026-07-02T14:54:11+03:00",
  "v3.7": "2026-07-02T14:54:11+03:00",
  "v3.6": "2026-07-02T14:54:11+03:00",
  "v3.5": "2026-03-27T13:18:47+02:00",
  "v3.4": "2026-03-27T13:18:47+02:00",
  "v3.3": "2026-03-27T13:18:47+02:00",
  "v3.2": "2026-03-27T13:18:47+02:00",
  "v3.1": "2026-03-27T13:18:47+02:00",
  "v3.0": "2026-03-27T13:18:47+02:00",
  "v2.0": "2026-03-27T13:18:47+02:00",
};

const formatPublishedTime = (version: string) => {
  const value = PUBLISHED_AT_BY_VERSION[version];
  if (!value) return "Ώρα μη καταγεγραμμένη";

  return new Intl.DateTimeFormat("el-GR", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "Europe/Athens",
  }).format(new Date(value));
};

const AdminChangelog: React.FC = () => {
  const [expanded, setExpanded] = useState<string | null>(ENTRIES[0].version);
  const [filter, setFilter] = useState<UpdateFilter>("all");

  const visibleEntries = useMemo(
    () => filter === "all" ? ENTRIES : ENTRIES.filter((entry) => entry.type === filter),
    [filter],
  );

  const uniqueMonths = useMemo(
    () => new Set(ENTRIES.map((entry) => entry.date.split(" ").slice(1).join(" "))).size,
    [],
  );

  return (
    <section className="space-y-5 animate-fade-in">
      <header className="border-b border-slate-200 pb-5">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.08em] text-red-600">
              <History className="h-4 w-4" /> Lineweb Updates
            </p>
            <h1 className="mt-1 text-2xl font-black tracking-tight text-slate-950 sm:text-3xl">
              Τι βελτιώνουμε στη Διαθερμική
            </h1>
            <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-500">
              Καθαρή εικόνα των αλλαγών που έχουν παραδοθεί στη διαχείριση leads, στους συνεργάτες,
              στις ειδοποιήσεις και στην υποδομή.
            </p>
          </div>
          <span className="inline-flex w-fit items-center gap-2 rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-xs font-bold text-emerald-700">
            <Check className="h-4 w-4" /> Ενημερωμένο
          </span>
        </div>
      </header>

      <div className="grid overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm sm:grid-cols-3">
        <div className="border-b border-slate-200 px-4 py-4 sm:border-b-0 sm:border-r sm:px-5">
          <p className="text-xs font-semibold text-slate-500">Καταγεγραμμένες εκδόσεις</p>
          <p className="mt-1 text-2xl font-black text-slate-950">{ENTRIES.length}</p>
        </div>
        <div className="border-b border-slate-200 px-4 py-4 sm:border-b-0 sm:border-r sm:px-5">
          <p className="text-xs font-semibold text-slate-500">Περίοδος εξέλιξης</p>
          <p className="mt-1 text-2xl font-black text-slate-950">{uniqueMonths} μήνες</p>
        </div>
        <div className="px-4 py-4 sm:px-5">
          <p className="text-xs font-semibold text-slate-500">Τελευταία ενημέρωση</p>
          <p className="mt-1 text-base font-black text-slate-950">
            {ENTRIES[0].date}
            <span className="text-slate-400"> · {formatPublishedTime(ENTRIES[0].version)}</span>
          </p>
          <p className="mt-0.5 text-[11px] font-medium text-slate-400">Ώρα Ελλάδας</p>
        </div>
      </div>

      <div className="overflow-x-auto pb-1">
        <div className="inline-flex min-w-max gap-1 rounded-xl border border-slate-200 bg-white p-1 shadow-sm">
          {FILTERS.map((item) => (
            <button
              key={item.value}
              type="button"
              onClick={() => setFilter(item.value)}
              className={`min-h-11 rounded-lg px-3 text-xs font-bold transition-colors sm:px-4 ${
                filter === item.value
                  ? "bg-slate-950 text-white"
                  : "text-slate-600 hover:bg-slate-100 hover:text-slate-950"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>

      <div className="relative space-y-3 before:absolute before:bottom-4 before:left-5 before:top-4 before:w-px before:bg-slate-200 sm:before:left-[8.25rem]">
        {visibleEntries.map((entry) => {
          const cfg = TYPE_CONFIG[entry.type];
          const TypeIcon = cfg.icon;
          const isOpen = expanded === entry.version;
          return (
            <article
              key={entry.version}
              className="relative grid gap-3 sm:grid-cols-[7.25rem_minmax(0,1fr)] sm:gap-8"
            >
              <div className="hidden pt-5 text-right sm:block">
                <p className="text-xs font-bold text-slate-700">{entry.date}</p>
                <p className="mt-1 inline-flex items-center justify-end gap-1 text-[11px] font-medium text-slate-400">
                  <Clock3 className="h-3 w-3" /> {formatPublishedTime(entry.version)} · Ελλάδα
                </p>
              </div>

              <div className={`relative ml-11 rounded-xl border bg-white shadow-sm transition-shadow hover:shadow-md sm:ml-0 ${
                isOpen ? "border-slate-300" : "border-slate-200"
              }`}>
                <span
                  className="absolute -left-[1.875rem] top-6 flex h-3 w-3 items-center justify-center rounded-full bg-white ring-1 ring-slate-200 sm:-left-[1.375rem]"
                  aria-hidden="true"
                >
                  <span className={`h-1.5 w-1.5 rounded-full ${cfg.dotClass}`} />
                </span>

                <button
                  type="button"
                  className="flex min-h-16 w-full items-start gap-3 p-4 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-sky-500 sm:p-5"
                  aria-expanded={isOpen}
                  onClick={() => setExpanded(isOpen ? null : entry.version)}
                >
                  <div className="min-w-0 flex-1">
                    <div className="mb-2 flex flex-wrap items-center gap-2">
                      <span className="font-mono text-[11px] font-semibold text-slate-400">{entry.version}</span>
                      <span className={`inline-flex items-center gap-1 rounded-md border px-2 py-1 text-[10px] font-bold uppercase ${cfg.badgeClass}`}>
                        <TypeIcon className="h-3 w-3" /> {cfg.label}
                      </span>
                      <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-slate-500 sm:hidden">
                        <CalendarDays className="h-3.5 w-3.5" /> {entry.date}
                      </span>
                      <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-slate-400 sm:hidden">
                        <Clock3 className="h-3.5 w-3.5" /> {formatPublishedTime(entry.version)} · Ελλάδα
                      </span>
                    </div>
                    <h2 className="text-base font-black leading-snug text-slate-950 sm:text-lg">{entry.title}</h2>
                    {!isOpen && entry.items[0] && (
                      <p className="mt-2 line-clamp-2 text-sm leading-6 text-slate-500">{entry.items[0]}</p>
                    )}
                  </div>
                  <ChevronDown className={`mt-1 h-5 w-5 shrink-0 text-slate-400 transition-transform ${isOpen ? "rotate-180" : ""}`} />
                </button>

                {isOpen && (
                  <div className="border-t border-slate-100 px-4 pb-5 pt-4 sm:px-5">
                    <ul className="grid gap-2.5 lg:grid-cols-2">
                      {entry.items.map((item, i) => (
                        <li key={i} className="flex items-start gap-2 text-sm leading-6 text-slate-600">
                          <Wrench className="mt-1 h-3.5 w-3.5 shrink-0 text-red-500" />
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </article>
          );
        })}
      </div>

      <footer className="relative mt-8 overflow-hidden rounded-xl bg-slate-950 text-white shadow-sm">
        <div className="h-1 bg-red-600" />
        <div className="grid gap-8 px-5 py-7 sm:px-7 lg:grid-cols-[minmax(0,1.2fr)_minmax(320px,0.8fr)] lg:gap-12 lg:px-9 lg:py-9">
          <div>
            <div className="flex flex-col gap-4 min-[420px]:flex-row min-[420px]:items-center">
              <img
                src="/images/lineweb-logo.webp"
                alt="Lineweb Creative Digital Agency"
                className="h-14 w-auto self-start object-contain sm:h-16"
              />
              <div className="border-white/15 min-[420px]:border-l min-[420px]:pl-4">
                <p className="text-sm font-black text-white">Lineweb Creative Digital Agency</p>
                <p className="mt-1 text-xs font-bold text-red-400">Digital partner</p>
              </div>
            </div>

            <h2 className="mt-7 text-xl font-black text-white sm:text-2xl">
              Υλοποίηση &amp; τεχνική φροντίδα από τη Lineweb
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-6 text-slate-300">
              Σχεδιασμός, ανάπτυξη και συνεχής υποστήριξη της πλατφόρμας lead operations της Διαθερμικής.
            </p>
          </div>

          <div className="border-t border-white/10 pt-6 lg:border-l lg:border-t-0 lg:pl-8 lg:pt-0">
            <p className="text-[10px] font-bold uppercase tracking-[0.12em] text-slate-500">Επικοινωνία</p>
            <div className="mt-4 space-y-3">
              <a href="https://www.lineweb.gr/" target="_blank" rel="noopener noreferrer" className="flex min-h-11 items-center gap-3 text-sm font-semibold text-slate-200 transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500">
                <Globe2 className="h-4 w-4 shrink-0 text-red-500" /> www.lineweb.gr
              </a>
              <a href="mailto:info@lineweb.gr" className="flex min-h-11 items-center gap-3 text-sm font-semibold text-slate-200 transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500">
                <Mail className="h-4 w-4 shrink-0 text-red-500" /> info@lineweb.gr
              </a>
              <a href="tel:+302314020464" className="flex min-h-11 items-center gap-3 text-sm font-semibold text-slate-200 transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500">
                <Phone className="h-4 w-4 shrink-0 text-red-500" /> +30 231 402 0464
              </a>
              <a href="tel:+306983145811" className="flex min-h-11 items-center gap-3 text-sm font-semibold text-slate-200 transition-colors hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500">
                <Phone className="h-4 w-4 shrink-0 text-red-500" /> +30 698 314 5811
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-4 border-t border-white/10 bg-black/20 px-5 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-7 lg:px-9">
          <p className="text-xs text-slate-500">Συνεχής τεχνική υποστήριξη και εξέλιξη της πλατφόρμας.</p>
          <a
            href="https://www.lineweb.gr/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-lg bg-red-600 px-4 text-sm font-bold text-white transition-colors hover:bg-red-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white sm:w-auto"
          >
            Επισκεφθείτε τη Lineweb <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </footer>
    </section>
  );
};

export default AdminChangelog;
